/*
    BEEP BOP BOOP - I AM AN AUTO GENERATED FILE - DO NOT EDIT ME MANUALLY
*/


// Name: Object Tables 

import React from "react";
import GenericTable from "../../../clientShared/components/tables/GenericTable";
import {
	UserAccountContainer,
	UserAccountBalanceContainer,
	UserAccountBalanceSourceContainer,
	UserHistoryEntryContainer,
	BalanceChangeLogContainer,
	InternationalUserBankAccountContainer,
	USDomesticUserBankAccountContainer,
	UserBankAccountDeltaContainer,
	UserAccountSettingsContainer,
	AdminGhostUserAccountContainer,
	UserAccountFinalizationContainer,
	ThirdPartyUserAccountMappingContainer,
	PreviousEmailAddressContainer,
	PendingEmailChangeContainer,
	ArchivedPendingEmailChangeContainer,
	PasswordContainer,
	ExpiredPasswordContainer,
	PasswordResetContainer,
	DepositContainer,
	DepositInviteContainer,
	DepositAdjustmentContainer,
	DepositInterestContainer,
	DepositHistoryEntryContainer,
	DepositCloseRequestContainer,
	DepositUserStatsContainer,
	DepositBankMappingContainer,
	DepositBulkImportContainer,
	DepositInterestLogContainer,
	ArchivedDepositCloseRequestContainer,
	DepositWithheldFundsContainer,
	PMCReportTimetableContainer,
	DepositGroupContainer,
	DepositPostCloseAdjustmentContainer,
	DepositUserGroupContainer,
	PropertyGroupContainer,
	PropertyUserGroupContainer,
	DisputeContainer,
	DisputeSplitContainer,
	DisputeInterventionRequestContainer,
	PropertyContainer,
	PropertyAddressContainer,
	ComplianceContainer,
	ComplianceRuleContainer,
	ComplianceHistoryContainer,
	EmailTemplateContainer,
	EmailVerificationContainer,
	EmailVerificationRecordContainer,
	EmailEventContainer,
	SentEmailContainer,
	MailboxContainer,
	MailboxMetaDataContainer,
	MailboxMessageContainer,
	PermissionEntryContainer,
	PermissionLogEntryContainer,
	PermissionsOrganizationSettingsContainer,
	ResourcePermissionContainer,
	OrganizationContainer,
	OrganizationResourcePermissionRuleContainer,
	InvoiceContainer,
	InvoiceItemContainer,
	PaymentRequestContainer,
	StripePaymentLogContainer,
	UserWithdrawContainer,
	PriorityACHPaymentContainer,
	PriorityACHRecurringPaymentContainer,
	LoanApplicationContainer,
	LoanSystemInfoContainer,
	LoanContainer,
	LoanHistoryContainer,
	LoanPaymentLogContainer,
	StripeWebhookLogContainer,
	UserAccountPaymentProviderInfoContainer,
	SezzleOrderContainer,
	SezzleWebhookEventContainer,
	BankAccountContainer,
	BankAccountHistoricalInterestRateContainer,
	BankAccountInterestContainer,
	BankAccountBalanceRecordContainer,
	BankTransferContainer,
	BulkFundsTransferContainer,
	FundsLockContainer,
	FundsLockReleaseLogContainer,
	ReleasedFundsLockContainer,
	BalanceSourceTransferContainer,
	CreditUserAccountLogContainer,
	EventContainer,
	EventHookContainer,
	NotificationContainer,
	ActionItemContainer,
	UpdateLogContainer,
	StorageFileContainer,
	AttachedStorageFilesContainer,
	SystemHistoryEntryContainer,
	SnapshotContainer,
	IPAddressContainer,
	KnownIPAddressContainer,
	UserAgentContainer,
	KnownUserAgentContainer,
	SystemStatsContainer,
	ResourceNoteContainer,
	DeposifyTagContainer,
	PermanentLinkContainer,
	OnlineUserContainer,
	FrontendGeneralSettingsContainer,
	YardiScreeningWorksProXMLContainer,
	YardiVoyagerXMLContainer,
	YardiVoyagerTransactionContainer,
	YardiVoyagerResidentContainer,
	YardiVoyagerResidentCustomColumnContainer,
	YardiVoyagerPropertyUnitContainer,
	YardiVoyagerPropertyContainer,
	YardiVoyagerPMCServiceInterfaceVersionContainer,
	YardiVoyagerPMCContainer,
	YardiVoyagerPMCCredentialsContainer,
	YardiVoyagerPetContainer,
	YardiVoyagerILSGuestCardEventContainer,
	YardiVoyagerChargeContainer,
	YardiVoyagerChargeCodeContainer,
	YardiVoyagerDepositCreateIntentContainer,
	YardiVoyagerDepositCloseIntentContainer,
	YardiVoyagerDepositWithholdIntentContainer,
	YardiVoyagerEventContainer,
	YardiVoyagerFlexDepositIntentContainer,
	YardiVoyagerPhoneContainer,
	YardiVoyagerOtherOccupantContainer,
	YardiVoyagerPMCCustomColumnSettingsContainer,
	YardiVoyagerPMCStatsContainer,
	YardiVoyagerPMCStatsCollectorContainer,
	YardiVoyagerActiveScanLogEntryContainer,
	YardiVoyagerSystemSettingsContainer
} from "../containers/resourceContainers";

import {
	RESOURCE_TYPE_USER_ACCOUNT,
	RESOURCE_TYPE_USER_ACCOUNT_BALANCE,
	RESOURCE_TYPE_USER_ACCOUNT_BALANCE_SOURCE,
	RESOURCE_TYPE_USER_HISTORY_ENTRY,
	RESOURCE_TYPE_BALANCE_CHANGE_LOG,
	RESOURCE_TYPE_INTERNATIONAL_USER_BANK_ACCOUNT,
	RESOURCE_TYPE_US_DOMESTIC_USER_BANK_ACCOUNT,
	RESOURCE_TYPE_USER_BANK_ACCOUNT_DELTA,
	RESOURCE_TYPE_USER_ACCOUNT_SETTINGS,
	RESOURCE_TYPE_USER_ACCOUNT_ADMIN_GHOST,
	RESOURCE_TYPE_USER_ACCOUNT_FINALIZATION,
	RESOURCE_TYPE_THIRD_PARTY_USER_ACCOUNT_MAPPING,
	RESOURCE_TYPE_PREVIOUS_EMAIL_ADDRESS,
	RESOURCE_TYPE_PENDING_EMAIL_CHANGE,
	RESOURCE_TYPE_ARCHIVED_PENDING_EMAIL_CHANGE,
	RESOURCE_TYPE_PASSWORD,
	RESOURCE_TYPE_EXPIRED_PASSWORD,
	RESOURCE_TYPE_PASSWORD_RESET,
	RESOURCE_TYPE_DEPOSIT,
	RESOURCE_TYPE_DEPOSIT_INVITE,
	RESOURCE_TYPE_DEPOSIT_ADJUSTMENT,
	RESOURCE_TYPE_DEPOSIT_INTEREST,
	RESOURCE_TYPE_DEPOSIT_HISTORY_ENTRY,
	RESOURCE_TYPE_DEPOSIT_CLOSE_REQUEST,
	RESOURCE_TYPE_DEPOSIT_USER_STATS,
	RESOURCE_TYPE_DEPOSIT_BANK_MAPPING,
	RESOURCE_TYPE_DEPOSITS_BULK_IMPORT,
	RESOURCE_TYPE_DEPOSIT_INTEREST_LOG,
	RESOURCE_TYPE_ARCHIVED_DEPOSIT_CLOSE_REQUEST,
	RESOURCE_TYPE_DEPOSIT_WITHHELD_FUNDS,
	RESOURCE_TYPE_PMC_REPORT_TIMETABLE,
	RESOURCE_TYPE_DEPOSIT_GROUP,
	RESOURCE_TYPE_DEPOSIT_POST_CLOSE_ADJUSTMENT,
	RESOURCE_TYPE_DEPOSIT_USER_GROUP,
	RESOURCE_TYPE_PROPERTY_GROUP,
	RESOURCE_TYPE_PROPERTY_USER_GROUP,
	RESOURCE_TYPE_DISPUTE,
	RESOURCE_TYPE_DISPUTE_SPLIT,
	RESOURCE_TYPE_DISPUTE_INTERVENTION_REQUEST,
	RESOURCE_TYPE_PROPERTY,
	RESOURCE_TYPE_PROPERTY_ADDRESS,
	RESOURCE_TYPE_COMPLIANCE,
	RESOURCE_TYPE_COMPLIANCE_RULE,
	RESOURCE_TYPE_COMPLIANCE_HISTORY,
	RESOURCE_TYPE_EMAIL_TEMPLATE,
	RESOURCE_TYPE_EMAIL_VERIFICATION,
	RESOURCE_TYPE_EMAIL_VERIFICATION_RECORD,
	RESOURCE_TYPE_EMAIL_EVENT,
	RESOURCE_TYPE_SENT_EMAIL,
	RESOURCE_TYPE_MAILBOX,
	RESOURCE_TYPE_MAILBOX_META_DATA,
	RESOURCE_TYPE_MAILBOX_MESSAGE,
	RESOURCE_TYPE_PERMISSION_ENTRY,
	RESOURCE_TYPE_PERMISSION_LOG_ENTRY,
	RESOURCE_TYPE_PERMISSIONS_ORGANIZATION_SETTINGS,
	RESOURCE_TYPE_RESOURCE_PERMISSIONS,
	RESOURCE_TYPE_ORGANIZATION,
	RESOURCE_TYPE_ORGANIZATION_RESOURCE_PERMISSION_RULE,
	RESOURCE_TYPE_INVOICE,
	RESOURCE_TYPE_INVOICE_ITEM,
	RESOURCE_TYPE_PAYMENT_REQUEST,
	RESOURCE_TYPE_STRIPE_PAYMENT_LOG,
	RESOURCE_TYPE_USER_WITHDRAW,
	RESOURCE_TYPE_PRIORITY_ACH_PAYMENT,
	RESOURCE_TYPE_PRIORITY_ACH_RECURRING_PAYMENT,
	RESOURCE_TYPE_LOAN_APPLICATION,
	RESOURCE_TYPE_LOAN_SYSTEM_INFO,
	RESOURCE_TYPE_LOAN,
	RESOURCE_TYPE_LOAN_HISTORY,
	RESOURCE_TYPE_LOAN_PAYMENT_LOG,
	RESOURCE_TYPE_STRIPE_WEBHOOK_LOG,
	RESOURCE_TYPE_USER_ACCOUNT_PAYMENT_PROVIDER_INFO,
	RESOURCE_TYPE_SEZZLE_ORDER,
	RESOURCE_TYPE_SEZZLE_WEBHOOK_EVENT,
	RESOURCE_TYPE_BANK_ACCOUNT,
	RESOURCE_TYPE_BANK_ACCOUNT_HISTORICAL_INTEREST_RATE,
	RESOURCE_TYPE_BANK_ACCOUNT_INTEREST,
	RESOURCE_TYPE_BANK_ACCOUNT_BALANCE_RECORD,
	RESOURCE_TYPE_BANK_TRANSFER,
	RESOURCE_TYPE_BULK_FUNDS_TRANSFER,
	RESOURCE_TYPE_FUNDS_LOCK,
	RESOURCE_TYPE_FUNDS_LOCK_RELEASE_LOG,
	RESOURCE_TYPE_RELEASED_FUNDS_LOCK,
	RESOURCE_TYPE_BALANCE_SOURCE_TRANSFER,
	RESOURCE_TYPE_CREDIT_USER_ACCOUNT_LOG,
	RESOURCE_TYPE_EVENT,
	RESOURCE_TYPE_EVENT_HOOK,
	RESOURCE_TYPE_NOTIFICATION,
	RESOURCE_TYPE_ACTION_ITEM,
	RESOURCE_TYPE_UPDATE_LOG_ENTRY,
	RESOURCE_TYPE_STORAGE_FILE,
	RESOURCE_TYPE_ATTACHED_STORAGE_FILES,
	RESOURCE_TYPE_SYSTEM_HISTORY_ENTRY,
	RESOURCE_TYPE_SNAPSHOT,
	RESOURCE_TYPE_IP_ADDRESS,
	RESOURCE_TYPE_KNOWN_IP_ADDRESS,
	RESOURCE_TYPE_USER_AGENT,
	RESOURCE_TYPE_KNOWN_USER_AGENT,
	RESOURCE_TYPE_SYSTEM_STATS,
	RESOURCE_TYPE_RESOURCE_NOTE,
	RESOURCE_TYPE_DEPOSIFY_TAG,
	RESOURCE_TYPE_PERMANENT_LINK,
	RESOURCE_TYPE_ONLINE_USER,
	RESOURCE_TYPE_FRONTEND_GENERAL_SETTINGS,
	RESOURCE_TYPE_YARDI_SCREENING_WORKS_PRO_XML,
	RESOURCE_TYPE_YARDI_VOYAGER_XML,
	RESOURCE_TYPE_YARDI_VOYAGER_TRANSACTION,
	RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT,
	RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN,
	RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY_UNIT,
	RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_CREDENTIALS,
	RESOURCE_TYPE_YARDI_VOYAGER_PET,
	RESOURCE_TYPE_YARDI_VOYAGER_ILS_GUEST_CARD_EVENT,
	RESOURCE_TYPE_YARDI_VOYAGER_CHARGE,
	RESOURCE_TYPE_YARDI_VOYAGER_CHARGE_CODE,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CREATE_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_EVENT,
	RESOURCE_TYPE_YARDI_VOYAGER_FLEX_DEPOSIT_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_PHONE,
	RESOURCE_TYPE_YARDI_VOYAGER_OTHER_OCCUPANT,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS_COLLECTOR,
	RESOURCE_TYPE_YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY,
	RESOURCE_TYPE_YARDI_VOYAGER_SYSTEM_SETTINGS
} from "../../constants/resourceTypeConstants";
import {RESOURCE_TYPE_INFO} from "../../constants/resourceTypeInfo";
import {
	USER_ACCOUNT_JSON_SCHEMA,
	USER_ACCOUNT_BALANCE_JSON_SCHEMA,
	USER_ACCOUNT_BALANCE_SOURCE_JSON_SCHEMA,
	BALANCE_CHANGE_LOG_JSON_SCHEMA,
	INTERNATIONAL_USER_BANK_ACCOUNT_JSON_SCHEMA,
	US_DOMESTIC_USER_BANK_ACCOUNT_JSON_SCHEMA,
	USER_BANK_ACCOUNT_DELTA_JSON_SCHEMA,
	USER_ACCOUNT_SETTINGS_JSON_SCHEMA,
	ADMIN_GHOST_USER_ACCOUNT_JSON_SCHEMA,
	USER_ACCOUNT_FINALIZATION_JSON_SCHEMA,
	THIRD_PARTY_USER_ACCOUNT_MAPPING_JSON_SCHEMA,
	PREVIOUS_EMAIL_ADDRESS_JSON_SCHEMA,
	PENDING_EMAIL_CHANGE_JSON_SCHEMA,
	ARCHIVED_PENDING_EMAIL_CHANGE_JSON_SCHEMA,
	PASSWORD_JSON_SCHEMA,
	EXPIRED_PASSWORD_JSON_SCHEMA,
	PASSWORD_RESET_JSON_SCHEMA,
	EMAIL_VERIFICATION_JSON_SCHEMA,
	EMAIL_VERIFICATION_RECORD_JSON_SCHEMA,
	FUNDS_LOCK_JSON_SCHEMA,
	FUNDS_LOCK_RELEASE_LOG_JSON_SCHEMA,
	RELEASED_FUNDS_LOCK_JSON_SCHEMA,
	BALANCE_SOURCE_TRANSFER_JSON_SCHEMA,
	CREDIT_USER_ACCOUNT_LOG_JSON_SCHEMA
} from "../../jsonSchemas/UserAccountsServiceJSONSchemas.js";
import {
	USER_HISTORY_ENTRY_JSON_SCHEMA,
	DEPOSIT_HISTORY_ENTRY_JSON_SCHEMA,
	UPDATE_LOG_JSON_SCHEMA,
	SYSTEM_HISTORY_ENTRY_JSON_SCHEMA,
	SNAPSHOT_JSON_SCHEMA
} from "../../jsonSchemas/HistoryServiceJSONSchemas.js";
import {
	DEPOSIT_JSON_SCHEMA,
	DEPOSIT_INVITE_JSON_SCHEMA,
	DEPOSIT_ADJUSTMENT_JSON_SCHEMA,
	DEPOSIT_INTEREST_JSON_SCHEMA,
	DEPOSIT_CLOSE_REQUEST_JSON_SCHEMA,
	DEPOSIT_USER_STATS_JSON_SCHEMA,
	DEPOSIT_BANK_MAPPING_JSON_SCHEMA,
	DEPOSIT_BULK_IMPORT_JSON_SCHEMA,
	DEPOSIT_INTEREST_LOG_JSON_SCHEMA,
	ARCHIVED_DEPOSIT_CLOSE_REQUEST_JSON_SCHEMA,
	DEPOSIT_WITHHELD_FUNDS_JSON_SCHEMA,
	PMC_REPORT_TIMETABLE_JSON_SCHEMA,
	DEPOSIT_GROUP_JSON_SCHEMA,
	DEPOSIT_POST_CLOSE_ADJUSTMENT_JSON_SCHEMA,
	DEPOSIT_USER_GROUP_JSON_SCHEMA,
	PROPERTY_GROUP_JSON_SCHEMA,
	PROPERTY_USER_GROUP_JSON_SCHEMA,
	DISPUTE_JSON_SCHEMA,
	DISPUTE_SPLIT_JSON_SCHEMA,
	DISPUTE_INTERVENTION_REQUEST_JSON_SCHEMA,
	PROPERTY_JSON_SCHEMA,
	PROPERTY_ADDRESS_JSON_SCHEMA,
	COMPLIANCE_JSON_SCHEMA,
	COMPLIANCE_RULE_JSON_SCHEMA,
	COMPLIANCE_HISTORY_JSON_SCHEMA
} from "../../jsonSchemas/DepositsServiceJSONSchemas.js";
import {
	EMAIL_TEMPLATE_JSON_SCHEMA,
	EMAIL_EVENT_JSON_SCHEMA,
	SENT_EMAIL_JSON_SCHEMA,
	MAILBOX_JSON_SCHEMA,
	MAILBOX_META_DATA_JSON_SCHEMA,
	MAILBOX_MESSAGE_JSON_SCHEMA
} from "../../jsonSchemas/MessagingServiceJSONSchemas.js";
import {
	PERMISSION_ENTRY_JSON_SCHEMA,
	PERMISSION_LOG_ENTRY_JSON_SCHEMA,
	PERMISSIONS_ORGANIZATION_SETTINGS_JSON_SCHEMA,
	RESOURCE_PERMISSION_JSON_SCHEMA,
	ORGANIZATION_JSON_SCHEMA,
	ORGANIZATION_RESOURCE_PERMISSION_RULE_JSON_SCHEMA
} from "../../jsonSchemas/PermissionsServiceJSONSchemas.js";
import {
	INVOICE_JSON_SCHEMA,
	INVOICE_ITEM_JSON_SCHEMA,
	PAYMENT_REQUEST_JSON_SCHEMA,
	STRIPE_PAYMENT_LOG_JSON_SCHEMA,
	USER_WITHDRAW_JSON_SCHEMA,
	PRIORITY_ACH_PAYMENT_JSON_SCHEMA,
	PRIORITY_ACH_RECURRING_PAYMENT_JSON_SCHEMA,
	LOAN_APPLICATION_JSON_SCHEMA,
	LOAN_SYSTEM_INFO_JSON_SCHEMA,
	LOAN_JSON_SCHEMA,
	LOAN_HISTORY_JSON_SCHEMA,
	LOAN_PAYMENT_LOG_JSON_SCHEMA,
	STRIPE_WEBHOOK_LOG_JSON_SCHEMA,
	USER_ACCOUNT_PAYMENT_PROVIDER_INFO_JSON_SCHEMA,
	SEZZLE_ORDER_JSON_SCHEMA,
	SEZZLE_WEBHOOK_EVENT_JSON_SCHEMA
} from "../../jsonSchemas/PaymentsServiceJSONSchemas.js";
import {
	BANK_ACCOUNT_JSON_SCHEMA,
	BANK_ACCOUNT_HISTORICAL_INTEREST_RATE_JSON_SCHEMA,
	BANK_ACCOUNT_INTEREST_JSON_SCHEMA,
	BANK_ACCOUNT_BALANCE_RECORD_JSON_SCHEMA,
	BANK_TRANSFER_JSON_SCHEMA,
	BULK_FUNDS_TRANSFER_JSON_SCHEMA
} from "../../jsonSchemas/BankingServiceJSONSchemas.js";
import {
	EVENT_JSON_SCHEMA,
	EVENT_HOOK_JSON_SCHEMA,
	NOTIFICATION_JSON_SCHEMA,
	ACTION_ITEM_JSON_SCHEMA
} from "../../jsonSchemas/EventsServiceJSONSchemas.js";
import {
	STORAGE_FILE_JSON_SCHEMA,
	ATTACHED_STORAGE_FILES_JSON_SCHEMA
} from "../../jsonSchemas/StorageServiceJSONSchemas.js";
import {
	IP_ADDRESS_JSON_SCHEMA,
	KNOWN_IP_ADDRESS_JSON_SCHEMA,
	USER_AGENT_JSON_SCHEMA,
	KNOWN_USER_AGENT_JSON_SCHEMA
} from "../../jsonSchemas/SecurityServiceJSONSchemas.js";
import {
	SYSTEM_STATS_JSON_SCHEMA,
	RESOURCE_NOTE_JSON_SCHEMA,
	DEPOSIFY_TAG_JSON_SCHEMA,
	PERMANENT_LINK_JSON_SCHEMA
} from "../../jsonSchemas/SystemGeneralServiceJSONSchemas.js";
import {
	ONLINE_USER_JSON_SCHEMA,
	FRONTEND_GENERAL_SETTINGS_JSON_SCHEMA
} from "../../jsonSchemas/FrontendServiceJSONSchemas.js";
import {
	YARDI_SCREENING_WORKS_PRO_XML_JSON_SCHEMA,
	YARDI_VOYAGER_XML_JSON_SCHEMA,
	YARDI_VOYAGER_TRANSACTION_JSON_SCHEMA,
	YARDI_VOYAGER_RESIDENT_JSON_SCHEMA,
	YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN_JSON_SCHEMA,
	YARDI_VOYAGER_PROPERTY_UNIT_JSON_SCHEMA,
	YARDI_VOYAGER_PROPERTY_JSON_SCHEMA,
	YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION_JSON_SCHEMA,
	YARDI_VOYAGER_PMC_JSON_SCHEMA,
	YARDI_VOYAGER_PMC_CREDENTIALS_JSON_SCHEMA,
	YARDI_VOYAGER_PET_JSON_SCHEMA,
	YARDI_VOYAGER_ILS_GUEST_CARD_EVENT_JSON_SCHEMA,
	YARDI_VOYAGER_CHARGE_JSON_SCHEMA,
	YARDI_VOYAGER_CHARGE_CODE_JSON_SCHEMA,
	YARDI_VOYAGER_DEPOSIT_CREATE_INTENT_JSON_SCHEMA,
	YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT_JSON_SCHEMA,
	YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT_JSON_SCHEMA,
	YARDI_VOYAGER_EVENT_JSON_SCHEMA,
	YARDI_VOYAGER_FLEX_DEPOSIT_INTENT_JSON_SCHEMA,
	YARDI_VOYAGER_PHONE_JSON_SCHEMA,
	YARDI_VOYAGER_OTHER_OCCUPANT_JSON_SCHEMA,
	YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS_JSON_SCHEMA,
	YARDI_VOYAGER_PMC_STATS_JSON_SCHEMA,
	YARDI_VOYAGER_PMC_STATS_COLLECTOR_JSON_SCHEMA,
	YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY_JSON_SCHEMA,
	YARDI_VOYAGER_SYSTEM_SETTINGS_JSON_SCHEMA
} from "../../jsonSchemas/YardiServiceJSONSchemas.js";
import {
	USER_ACCOUNT_TABLE_RENDER_DEF,
	USER_ACCOUNT_BALANCE_TABLE_RENDER_DEF,
	USER_ACCOUNT_BALANCE_SOURCE_TABLE_RENDER_DEF,
	BALANCE_CHANGE_LOG_TABLE_RENDER_DEF,
	INTERNATIONAL_USER_BANK_ACCOUNT_TABLE_RENDER_DEF,
	US_DOMESTIC_USER_BANK_ACCOUNT_TABLE_RENDER_DEF,
	USER_BANK_ACCOUNT_DELTA_TABLE_RENDER_DEF,
	USER_ACCOUNT_SETTINGS_TABLE_RENDER_DEF,
	ADMIN_GHOST_USER_ACCOUNT_TABLE_RENDER_DEF,
	USER_ACCOUNT_FINALIZATION_TABLE_RENDER_DEF,
	THIRD_PARTY_USER_ACCOUNT_MAPPING_TABLE_RENDER_DEF,
	PREVIOUS_EMAIL_ADDRESS_TABLE_RENDER_DEF,
	PENDING_EMAIL_CHANGE_TABLE_RENDER_DEF,
	ARCHIVED_PENDING_EMAIL_CHANGE_TABLE_RENDER_DEF,
	PASSWORD_TABLE_RENDER_DEF,
	EXPIRED_PASSWORD_TABLE_RENDER_DEF,
	PASSWORD_RESET_TABLE_RENDER_DEF,
	EMAIL_VERIFICATION_TABLE_RENDER_DEF,
	EMAIL_VERIFICATION_RECORD_TABLE_RENDER_DEF,
	FUNDS_LOCK_TABLE_RENDER_DEF,
	FUNDS_LOCK_RELEASE_LOG_TABLE_RENDER_DEF,
	RELEASED_FUNDS_LOCK_TABLE_RENDER_DEF,
	BALANCE_SOURCE_TRANSFER_TABLE_RENDER_DEF,
	CREDIT_USER_ACCOUNT_LOG_TABLE_RENDER_DEF
} from "../../../clientShared/constants/tables/renderDefinitions/UserAccountsServiceTableRenderDefinitions.js";
import {
	USER_HISTORY_ENTRY_TABLE_RENDER_DEF,
	DEPOSIT_HISTORY_ENTRY_TABLE_RENDER_DEF,
	UPDATE_LOG_TABLE_RENDER_DEF,
	SYSTEM_HISTORY_ENTRY_TABLE_RENDER_DEF,
	SNAPSHOT_TABLE_RENDER_DEF
} from "../../../clientShared/constants/tables/renderDefinitions/HistoryServiceTableRenderDefinitions.js";
import {
	DEPOSIT_TABLE_RENDER_DEF,
	DEPOSIT_INVITE_TABLE_RENDER_DEF,
	DEPOSIT_ADJUSTMENT_TABLE_RENDER_DEF,
	DEPOSIT_INTEREST_TABLE_RENDER_DEF,
	DEPOSIT_CLOSE_REQUEST_TABLE_RENDER_DEF,
	DEPOSIT_USER_STATS_TABLE_RENDER_DEF,
	DEPOSIT_BANK_MAPPING_TABLE_RENDER_DEF,
	DEPOSIT_BULK_IMPORT_TABLE_RENDER_DEF,
	DEPOSIT_INTEREST_LOG_TABLE_RENDER_DEF,
	ARCHIVED_DEPOSIT_CLOSE_REQUEST_TABLE_RENDER_DEF,
	DEPOSIT_WITHHELD_FUNDS_TABLE_RENDER_DEF,
	PMC_REPORT_TIMETABLE_TABLE_RENDER_DEF,
	DEPOSIT_GROUP_TABLE_RENDER_DEF,
	DEPOSIT_POST_CLOSE_ADJUSTMENT_TABLE_RENDER_DEF,
	DEPOSIT_USER_GROUP_TABLE_RENDER_DEF,
	PROPERTY_GROUP_TABLE_RENDER_DEF,
	PROPERTY_USER_GROUP_TABLE_RENDER_DEF,
	DISPUTE_TABLE_RENDER_DEF,
	DISPUTE_SPLIT_TABLE_RENDER_DEF,
	DISPUTE_INTERVENTION_REQUEST_TABLE_RENDER_DEF,
	PROPERTY_TABLE_RENDER_DEF,
	PROPERTY_ADDRESS_TABLE_RENDER_DEF,
	COMPLIANCE_TABLE_RENDER_DEF,
	COMPLIANCE_RULE_TABLE_RENDER_DEF,
	COMPLIANCE_HISTORY_TABLE_RENDER_DEF
} from "../../../clientShared/constants/tables/renderDefinitions/DepositsServiceTableRenderDefinitions.js";
import {
	EMAIL_TEMPLATE_TABLE_RENDER_DEF,
	EMAIL_EVENT_TABLE_RENDER_DEF,
	SENT_EMAIL_TABLE_RENDER_DEF,
	MAILBOX_TABLE_RENDER_DEF,
	MAILBOX_META_DATA_TABLE_RENDER_DEF,
	MAILBOX_MESSAGE_TABLE_RENDER_DEF
} from "../../../clientShared/constants/tables/renderDefinitions/MessagingServiceTableRenderDefinitions.js";
import {
	PERMISSION_ENTRY_TABLE_RENDER_DEF,
	PERMISSION_LOG_ENTRY_TABLE_RENDER_DEF,
	PERMISSIONS_ORGANIZATION_SETTINGS_TABLE_RENDER_DEF,
	RESOURCE_PERMISSION_TABLE_RENDER_DEF,
	ORGANIZATION_TABLE_RENDER_DEF,
	ORGANIZATION_RESOURCE_PERMISSION_RULE_TABLE_RENDER_DEF
} from "../../../clientShared/constants/tables/renderDefinitions/PermissionsServiceTableRenderDefinitions.js";
import {
	INVOICE_TABLE_RENDER_DEF,
	INVOICE_ITEM_TABLE_RENDER_DEF,
	PAYMENT_REQUEST_TABLE_RENDER_DEF,
	STRIPE_PAYMENT_LOG_TABLE_RENDER_DEF,
	USER_WITHDRAW_TABLE_RENDER_DEF,
	PRIORITY_ACH_PAYMENT_TABLE_RENDER_DEF,
	PRIORITY_ACH_RECURRING_PAYMENT_TABLE_RENDER_DEF,
	LOAN_APPLICATION_TABLE_RENDER_DEF,
	LOAN_SYSTEM_INFO_TABLE_RENDER_DEF,
	LOAN_TABLE_RENDER_DEF,
	LOAN_HISTORY_TABLE_RENDER_DEF,
	LOAN_PAYMENT_LOG_TABLE_RENDER_DEF,
	STRIPE_WEBHOOK_LOG_TABLE_RENDER_DEF,
	USER_ACCOUNT_PAYMENT_PROVIDER_INFO_TABLE_RENDER_DEF,
	SEZZLE_ORDER_TABLE_RENDER_DEF,
	SEZZLE_WEBHOOK_EVENT_TABLE_RENDER_DEF
} from "../../../clientShared/constants/tables/renderDefinitions/PaymentsServiceTableRenderDefinitions.js";
import {
	BANK_ACCOUNT_TABLE_RENDER_DEF,
	BANK_ACCOUNT_HISTORICAL_INTEREST_RATE_TABLE_RENDER_DEF,
	BANK_ACCOUNT_INTEREST_TABLE_RENDER_DEF,
	BANK_ACCOUNT_BALANCE_RECORD_TABLE_RENDER_DEF,
	BANK_TRANSFER_TABLE_RENDER_DEF,
	BULK_FUNDS_TRANSFER_TABLE_RENDER_DEF
} from "../../../clientShared/constants/tables/renderDefinitions/BankingServiceTableRenderDefinitions.js";
import {
	EVENT_TABLE_RENDER_DEF,
	EVENT_HOOK_TABLE_RENDER_DEF,
	NOTIFICATION_TABLE_RENDER_DEF,
	ACTION_ITEM_TABLE_RENDER_DEF
} from "../../../clientShared/constants/tables/renderDefinitions/EventsServiceTableRenderDefinitions.js";
import {
	STORAGE_FILE_TABLE_RENDER_DEF,
	ATTACHED_STORAGE_FILES_TABLE_RENDER_DEF
} from "../../../clientShared/constants/tables/renderDefinitions/StorageServiceTableRenderDefinitions.js";
import {
	IP_ADDRESS_TABLE_RENDER_DEF,
	KNOWN_IP_ADDRESS_TABLE_RENDER_DEF,
	USER_AGENT_TABLE_RENDER_DEF,
	KNOWN_USER_AGENT_TABLE_RENDER_DEF
} from "../../../clientShared/constants/tables/renderDefinitions/SecurityServiceTableRenderDefinitions.js";
import {
	SYSTEM_STATS_TABLE_RENDER_DEF,
	RESOURCE_NOTE_TABLE_RENDER_DEF,
	DEPOSIFY_TAG_TABLE_RENDER_DEF,
	PERMANENT_LINK_TABLE_RENDER_DEF
} from "../../../clientShared/constants/tables/renderDefinitions/SystemGeneralServiceTableRenderDefinitions.js";
import {
	ONLINE_USER_TABLE_RENDER_DEF,
	FRONTEND_GENERAL_SETTINGS_TABLE_RENDER_DEF
} from "../../../clientShared/constants/tables/renderDefinitions/FrontendServiceTableRenderDefinitions.js";
import {
	YARDI_SCREENING_WORKS_PRO_XML_TABLE_RENDER_DEF,
	YARDI_VOYAGER_XML_TABLE_RENDER_DEF,
	YARDI_VOYAGER_TRANSACTION_TABLE_RENDER_DEF,
	YARDI_VOYAGER_RESIDENT_TABLE_RENDER_DEF,
	YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN_TABLE_RENDER_DEF,
	YARDI_VOYAGER_PROPERTY_UNIT_TABLE_RENDER_DEF,
	YARDI_VOYAGER_PROPERTY_TABLE_RENDER_DEF,
	YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION_TABLE_RENDER_DEF,
	YARDI_VOYAGER_PMC_TABLE_RENDER_DEF,
	YARDI_VOYAGER_PMC_CREDENTIALS_TABLE_RENDER_DEF,
	YARDI_VOYAGER_PET_TABLE_RENDER_DEF,
	YARDI_VOYAGER_ILS_GUEST_CARD_EVENT_TABLE_RENDER_DEF,
	YARDI_VOYAGER_CHARGE_TABLE_RENDER_DEF,
	YARDI_VOYAGER_CHARGE_CODE_TABLE_RENDER_DEF,
	YARDI_VOYAGER_DEPOSIT_CREATE_INTENT_TABLE_RENDER_DEF,
	YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT_TABLE_RENDER_DEF,
	YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT_TABLE_RENDER_DEF,
	YARDI_VOYAGER_EVENT_TABLE_RENDER_DEF,
	YARDI_VOYAGER_FLEX_DEPOSIT_INTENT_TABLE_RENDER_DEF,
	YARDI_VOYAGER_PHONE_TABLE_RENDER_DEF,
	YARDI_VOYAGER_OTHER_OCCUPANT_TABLE_RENDER_DEF,
	YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS_TABLE_RENDER_DEF,
	YARDI_VOYAGER_PMC_STATS_TABLE_RENDER_DEF,
	YARDI_VOYAGER_PMC_STATS_COLLECTOR_TABLE_RENDER_DEF,
	YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY_TABLE_RENDER_DEF,
	YARDI_VOYAGER_SYSTEM_SETTINGS_TABLE_RENDER_DEF
} from "../../../clientShared/constants/tables/renderDefinitions/YardiServiceTableRenderDefinitions.js";
import {
	USER_ACCOUNT_CUSTOM_RENDER_COMPONENTS,
	USER_ACCOUNT_BALANCE_CUSTOM_RENDER_COMPONENTS,
	USER_ACCOUNT_BALANCE_SOURCE_CUSTOM_RENDER_COMPONENTS,
	BALANCE_CHANGE_LOG_CUSTOM_RENDER_COMPONENTS,
	INTERNATIONAL_USER_BANK_ACCOUNT_CUSTOM_RENDER_COMPONENTS,
	US_DOMESTIC_USER_BANK_ACCOUNT_CUSTOM_RENDER_COMPONENTS,
	USER_BANK_ACCOUNT_DELTA_CUSTOM_RENDER_COMPONENTS,
	USER_ACCOUNT_SETTINGS_CUSTOM_RENDER_COMPONENTS,
	ADMIN_GHOST_USER_ACCOUNT_CUSTOM_RENDER_COMPONENTS,
	USER_ACCOUNT_FINALIZATION_CUSTOM_RENDER_COMPONENTS,
	THIRD_PARTY_USER_ACCOUNT_MAPPING_CUSTOM_RENDER_COMPONENTS,
	PREVIOUS_EMAIL_ADDRESS_CUSTOM_RENDER_COMPONENTS,
	PENDING_EMAIL_CHANGE_CUSTOM_RENDER_COMPONENTS,
	ARCHIVED_PENDING_EMAIL_CHANGE_CUSTOM_RENDER_COMPONENTS,
	PASSWORD_CUSTOM_RENDER_COMPONENTS,
	EXPIRED_PASSWORD_CUSTOM_RENDER_COMPONENTS,
	PASSWORD_RESET_CUSTOM_RENDER_COMPONENTS,
	EMAIL_VERIFICATION_CUSTOM_RENDER_COMPONENTS,
	EMAIL_VERIFICATION_RECORD_CUSTOM_RENDER_COMPONENTS,
	FUNDS_LOCK_CUSTOM_RENDER_COMPONENTS,
	FUNDS_LOCK_RELEASE_LOG_CUSTOM_RENDER_COMPONENTS,
	RELEASED_FUNDS_LOCK_CUSTOM_RENDER_COMPONENTS,
	BALANCE_SOURCE_TRANSFER_CUSTOM_RENDER_COMPONENTS,
	CREDIT_USER_ACCOUNT_LOG_CUSTOM_RENDER_COMPONENTS
} from "../../../clientShared/constants/renderers/UserAccountsServiceCustomRenderComponents.js";
import {
	USER_HISTORY_ENTRY_CUSTOM_RENDER_COMPONENTS,
	DEPOSIT_HISTORY_ENTRY_CUSTOM_RENDER_COMPONENTS,
	UPDATE_LOG_CUSTOM_RENDER_COMPONENTS,
	SYSTEM_HISTORY_ENTRY_CUSTOM_RENDER_COMPONENTS,
	SNAPSHOT_CUSTOM_RENDER_COMPONENTS
} from "../../../clientShared/constants/renderers/HistoryServiceCustomRenderComponents.js";
import {
	DEPOSIT_CUSTOM_RENDER_COMPONENTS,
	DEPOSIT_INVITE_CUSTOM_RENDER_COMPONENTS,
	DEPOSIT_ADJUSTMENT_CUSTOM_RENDER_COMPONENTS,
	DEPOSIT_INTEREST_CUSTOM_RENDER_COMPONENTS,
	DEPOSIT_CLOSE_REQUEST_CUSTOM_RENDER_COMPONENTS,
	DEPOSIT_USER_STATS_CUSTOM_RENDER_COMPONENTS,
	DEPOSIT_BANK_MAPPING_CUSTOM_RENDER_COMPONENTS,
	DEPOSIT_BULK_IMPORT_CUSTOM_RENDER_COMPONENTS,
	DEPOSIT_INTEREST_LOG_CUSTOM_RENDER_COMPONENTS,
	ARCHIVED_DEPOSIT_CLOSE_REQUEST_CUSTOM_RENDER_COMPONENTS,
	DEPOSIT_WITHHELD_FUNDS_CUSTOM_RENDER_COMPONENTS,
	PMC_REPORT_TIMETABLE_CUSTOM_RENDER_COMPONENTS,
	DEPOSIT_GROUP_CUSTOM_RENDER_COMPONENTS,
	DEPOSIT_POST_CLOSE_ADJUSTMENT_CUSTOM_RENDER_COMPONENTS,
	DEPOSIT_USER_GROUP_CUSTOM_RENDER_COMPONENTS,
	PROPERTY_GROUP_CUSTOM_RENDER_COMPONENTS,
	PROPERTY_USER_GROUP_CUSTOM_RENDER_COMPONENTS,
	DISPUTE_CUSTOM_RENDER_COMPONENTS,
	DISPUTE_SPLIT_CUSTOM_RENDER_COMPONENTS,
	DISPUTE_INTERVENTION_REQUEST_CUSTOM_RENDER_COMPONENTS,
	PROPERTY_CUSTOM_RENDER_COMPONENTS,
	PROPERTY_ADDRESS_CUSTOM_RENDER_COMPONENTS,
	COMPLIANCE_CUSTOM_RENDER_COMPONENTS,
	COMPLIANCE_RULE_CUSTOM_RENDER_COMPONENTS,
	COMPLIANCE_HISTORY_CUSTOM_RENDER_COMPONENTS
} from "../../../clientShared/constants/renderers/DepositsServiceCustomRenderComponents.js";
import {
	EMAIL_TEMPLATE_CUSTOM_RENDER_COMPONENTS,
	EMAIL_EVENT_CUSTOM_RENDER_COMPONENTS,
	SENT_EMAIL_CUSTOM_RENDER_COMPONENTS,
	MAILBOX_CUSTOM_RENDER_COMPONENTS,
	MAILBOX_META_DATA_CUSTOM_RENDER_COMPONENTS,
	MAILBOX_MESSAGE_CUSTOM_RENDER_COMPONENTS
} from "../../../clientShared/constants/renderers/MessagingServiceCustomRenderComponents.js";
import {
	PERMISSION_ENTRY_CUSTOM_RENDER_COMPONENTS,
	PERMISSION_LOG_ENTRY_CUSTOM_RENDER_COMPONENTS,
	PERMISSIONS_ORGANIZATION_SETTINGS_CUSTOM_RENDER_COMPONENTS,
	RESOURCE_PERMISSION_CUSTOM_RENDER_COMPONENTS,
	ORGANIZATION_CUSTOM_RENDER_COMPONENTS,
	ORGANIZATION_RESOURCE_PERMISSION_RULE_CUSTOM_RENDER_COMPONENTS
} from "../../../clientShared/constants/renderers/PermissionsServiceCustomRenderComponents.js";
import {
	INVOICE_CUSTOM_RENDER_COMPONENTS,
	INVOICE_ITEM_CUSTOM_RENDER_COMPONENTS,
	PAYMENT_REQUEST_CUSTOM_RENDER_COMPONENTS,
	STRIPE_PAYMENT_LOG_CUSTOM_RENDER_COMPONENTS,
	USER_WITHDRAW_CUSTOM_RENDER_COMPONENTS,
	PRIORITY_ACH_PAYMENT_CUSTOM_RENDER_COMPONENTS,
	PRIORITY_ACH_RECURRING_PAYMENT_CUSTOM_RENDER_COMPONENTS,
	LOAN_APPLICATION_CUSTOM_RENDER_COMPONENTS,
	LOAN_SYSTEM_INFO_CUSTOM_RENDER_COMPONENTS,
	LOAN_CUSTOM_RENDER_COMPONENTS,
	LOAN_HISTORY_CUSTOM_RENDER_COMPONENTS,
	LOAN_PAYMENT_LOG_CUSTOM_RENDER_COMPONENTS,
	STRIPE_WEBHOOK_LOG_CUSTOM_RENDER_COMPONENTS,
	USER_ACCOUNT_PAYMENT_PROVIDER_INFO_CUSTOM_RENDER_COMPONENTS,
	SEZZLE_ORDER_CUSTOM_RENDER_COMPONENTS,
	SEZZLE_WEBHOOK_EVENT_CUSTOM_RENDER_COMPONENTS
} from "../../../clientShared/constants/renderers/PaymentsServiceCustomRenderComponents.js";
import {
	BANK_ACCOUNT_CUSTOM_RENDER_COMPONENTS,
	BANK_ACCOUNT_HISTORICAL_INTEREST_RATE_CUSTOM_RENDER_COMPONENTS,
	BANK_ACCOUNT_INTEREST_CUSTOM_RENDER_COMPONENTS,
	BANK_ACCOUNT_BALANCE_RECORD_CUSTOM_RENDER_COMPONENTS,
	BANK_TRANSFER_CUSTOM_RENDER_COMPONENTS,
	BULK_FUNDS_TRANSFER_CUSTOM_RENDER_COMPONENTS
} from "../../../clientShared/constants/renderers/BankingServiceCustomRenderComponents.js";
import {
	EVENT_CUSTOM_RENDER_COMPONENTS,
	EVENT_HOOK_CUSTOM_RENDER_COMPONENTS,
	NOTIFICATION_CUSTOM_RENDER_COMPONENTS,
	ACTION_ITEM_CUSTOM_RENDER_COMPONENTS
} from "../../../clientShared/constants/renderers/EventsServiceCustomRenderComponents.js";
import {
	STORAGE_FILE_CUSTOM_RENDER_COMPONENTS,
	ATTACHED_STORAGE_FILES_CUSTOM_RENDER_COMPONENTS
} from "../../../clientShared/constants/renderers/StorageServiceCustomRenderComponents.js";
import {
	IP_ADDRESS_CUSTOM_RENDER_COMPONENTS,
	KNOWN_IP_ADDRESS_CUSTOM_RENDER_COMPONENTS,
	USER_AGENT_CUSTOM_RENDER_COMPONENTS,
	KNOWN_USER_AGENT_CUSTOM_RENDER_COMPONENTS
} from "../../../clientShared/constants/renderers/SecurityServiceCustomRenderComponents.js";
import {
	SYSTEM_STATS_CUSTOM_RENDER_COMPONENTS,
	RESOURCE_NOTE_CUSTOM_RENDER_COMPONENTS,
	DEPOSIFY_TAG_CUSTOM_RENDER_COMPONENTS,
	PERMANENT_LINK_CUSTOM_RENDER_COMPONENTS
} from "../../../clientShared/constants/renderers/SystemGeneralServiceCustomRenderComponents.js";
import {
	ONLINE_USER_CUSTOM_RENDER_COMPONENTS,
	FRONTEND_GENERAL_SETTINGS_CUSTOM_RENDER_COMPONENTS
} from "../../../clientShared/constants/renderers/FrontendServiceCustomRenderComponents.js";
import {
	YARDI_SCREENING_WORKS_PRO_XML_CUSTOM_RENDER_COMPONENTS,
	YARDI_VOYAGER_XML_CUSTOM_RENDER_COMPONENTS,
	YARDI_VOYAGER_TRANSACTION_CUSTOM_RENDER_COMPONENTS,
	YARDI_VOYAGER_RESIDENT_CUSTOM_RENDER_COMPONENTS,
	YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN_CUSTOM_RENDER_COMPONENTS,
	YARDI_VOYAGER_PROPERTY_UNIT_CUSTOM_RENDER_COMPONENTS,
	YARDI_VOYAGER_PROPERTY_CUSTOM_RENDER_COMPONENTS,
	YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION_CUSTOM_RENDER_COMPONENTS,
	YARDI_VOYAGER_PMC_CUSTOM_RENDER_COMPONENTS,
	YARDI_VOYAGER_PMC_CREDENTIALS_CUSTOM_RENDER_COMPONENTS,
	YARDI_VOYAGER_PET_CUSTOM_RENDER_COMPONENTS,
	YARDI_VOYAGER_ILS_GUEST_CARD_EVENT_CUSTOM_RENDER_COMPONENTS,
	YARDI_VOYAGER_CHARGE_CUSTOM_RENDER_COMPONENTS,
	YARDI_VOYAGER_CHARGE_CODE_CUSTOM_RENDER_COMPONENTS,
	YARDI_VOYAGER_DEPOSIT_CREATE_INTENT_CUSTOM_RENDER_COMPONENTS,
	YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT_CUSTOM_RENDER_COMPONENTS,
	YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT_CUSTOM_RENDER_COMPONENTS,
	YARDI_VOYAGER_EVENT_CUSTOM_RENDER_COMPONENTS,
	YARDI_VOYAGER_FLEX_DEPOSIT_INTENT_CUSTOM_RENDER_COMPONENTS,
	YARDI_VOYAGER_PHONE_CUSTOM_RENDER_COMPONENTS,
	YARDI_VOYAGER_OTHER_OCCUPANT_CUSTOM_RENDER_COMPONENTS,
	YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS_CUSTOM_RENDER_COMPONENTS,
	YARDI_VOYAGER_PMC_STATS_CUSTOM_RENDER_COMPONENTS,
	YARDI_VOYAGER_PMC_STATS_COLLECTOR_CUSTOM_RENDER_COMPONENTS,
	YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY_CUSTOM_RENDER_COMPONENTS,
	YARDI_VOYAGER_SYSTEM_SETTINGS_CUSTOM_RENDER_COMPONENTS
} from "../../../clientShared/constants/renderers/YardiServiceCustomRenderComponents.js";

export function UserAccountsTable({accountUIDList}) {
	return (
		<GenericTable
			incomingUIDList={accountUIDList}
			tableRenderDefinition={USER_ACCOUNT_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_USER_ACCOUNT}
			loadingContainer={UserAccountContainer}
			jsonSchema={USER_ACCOUNT_JSON_SCHEMA}
			customRenderComponents={USER_ACCOUNT_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function UserAccountBalancesTable({accountUIDList}) {
	return (
		<GenericTable
			incomingUIDList={accountUIDList}
			tableRenderDefinition={USER_ACCOUNT_BALANCE_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_USER_ACCOUNT_BALANCE}
			loadingContainer={UserAccountBalanceContainer}
			jsonSchema={USER_ACCOUNT_BALANCE_JSON_SCHEMA}
			customRenderComponents={USER_ACCOUNT_BALANCE_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function UserAccountBalanceSourcesTable({sourceUIDList}) {
	return (
		<GenericTable
			incomingUIDList={sourceUIDList}
			tableRenderDefinition={USER_ACCOUNT_BALANCE_SOURCE_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_USER_ACCOUNT_BALANCE_SOURCE}
			loadingContainer={UserAccountBalanceSourceContainer}
			jsonSchema={USER_ACCOUNT_BALANCE_SOURCE_JSON_SCHEMA}
			customRenderComponents={USER_ACCOUNT_BALANCE_SOURCE_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function UserHistoryEntriesTable({entryUIDList}) {
	return (
		<GenericTable
			incomingUIDList={entryUIDList}
			tableRenderDefinition={USER_HISTORY_ENTRY_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_USER_HISTORY_ENTRY}
			loadingContainer={UserHistoryEntryContainer}
			jsonSchema={USER_HISTORY_ENTRY_JSON_SCHEMA}
			customRenderComponents={USER_HISTORY_ENTRY_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function BalanceChangeLogsTable({changeLogUIDList}) {
	return (
		<GenericTable
			incomingUIDList={changeLogUIDList}
			tableRenderDefinition={BALANCE_CHANGE_LOG_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_BALANCE_CHANGE_LOG}
			loadingContainer={BalanceChangeLogContainer}
			jsonSchema={BALANCE_CHANGE_LOG_JSON_SCHEMA}
			customRenderComponents={BALANCE_CHANGE_LOG_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function InternationalBankAccountsTable({bankAccountUIDList}) {
	return (
		<GenericTable
			incomingUIDList={bankAccountUIDList}
			tableRenderDefinition={INTERNATIONAL_USER_BANK_ACCOUNT_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_INTERNATIONAL_USER_BANK_ACCOUNT}
			loadingContainer={InternationalUserBankAccountContainer}
			jsonSchema={INTERNATIONAL_USER_BANK_ACCOUNT_JSON_SCHEMA}
			customRenderComponents={INTERNATIONAL_USER_BANK_ACCOUNT_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function USDomesticBankAccountsTable({bankAccountUIDList}) {
	return (
		<GenericTable
			incomingUIDList={bankAccountUIDList}
			tableRenderDefinition={US_DOMESTIC_USER_BANK_ACCOUNT_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_US_DOMESTIC_USER_BANK_ACCOUNT}
			loadingContainer={USDomesticUserBankAccountContainer}
			jsonSchema={US_DOMESTIC_USER_BANK_ACCOUNT_JSON_SCHEMA}
			customRenderComponents={US_DOMESTIC_USER_BANK_ACCOUNT_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function UserBankAccountDeltasTable({deltaUIDList}) {
	return (
		<GenericTable
			incomingUIDList={deltaUIDList}
			tableRenderDefinition={USER_BANK_ACCOUNT_DELTA_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_USER_BANK_ACCOUNT_DELTA}
			loadingContainer={UserBankAccountDeltaContainer}
			jsonSchema={USER_BANK_ACCOUNT_DELTA_JSON_SCHEMA}
			customRenderComponents={USER_BANK_ACCOUNT_DELTA_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function UserAccountSettingsTable({accountUIDList}) {
	return (
		<GenericTable
			incomingUIDList={accountUIDList}
			tableRenderDefinition={USER_ACCOUNT_SETTINGS_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_USER_ACCOUNT_SETTINGS}
			loadingContainer={UserAccountSettingsContainer}
			jsonSchema={USER_ACCOUNT_SETTINGS_JSON_SCHEMA}
			customRenderComponents={USER_ACCOUNT_SETTINGS_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function AdminGhostUserAccountsTable({ghostAccountUIDList}) {
	return (
		<GenericTable
			incomingUIDList={ghostAccountUIDList}
			tableRenderDefinition={ADMIN_GHOST_USER_ACCOUNT_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_USER_ACCOUNT_ADMIN_GHOST}
			loadingContainer={AdminGhostUserAccountContainer}
			jsonSchema={ADMIN_GHOST_USER_ACCOUNT_JSON_SCHEMA}
			customRenderComponents={ADMIN_GHOST_USER_ACCOUNT_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function UserAccountFinalizationsTable({accountUIDList}) {
	return (
		<GenericTable
			incomingUIDList={accountUIDList}
			tableRenderDefinition={USER_ACCOUNT_FINALIZATION_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_USER_ACCOUNT_FINALIZATION}
			loadingContainer={UserAccountFinalizationContainer}
			jsonSchema={USER_ACCOUNT_FINALIZATION_JSON_SCHEMA}
			customRenderComponents={USER_ACCOUNT_FINALIZATION_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function ThirdPartyUserAccountMappingsTable({accountUIDList}) {
	return (
		<GenericTable
			incomingUIDList={accountUIDList}
			tableRenderDefinition={THIRD_PARTY_USER_ACCOUNT_MAPPING_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_THIRD_PARTY_USER_ACCOUNT_MAPPING}
			loadingContainer={ThirdPartyUserAccountMappingContainer}
			jsonSchema={THIRD_PARTY_USER_ACCOUNT_MAPPING_JSON_SCHEMA}
			customRenderComponents={THIRD_PARTY_USER_ACCOUNT_MAPPING_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function PreviousEmailAddressesTable({previousEmailUIDList}) {
	return (
		<GenericTable
			incomingUIDList={previousEmailUIDList}
			tableRenderDefinition={PREVIOUS_EMAIL_ADDRESS_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_PREVIOUS_EMAIL_ADDRESS}
			loadingContainer={PreviousEmailAddressContainer}
			jsonSchema={PREVIOUS_EMAIL_ADDRESS_JSON_SCHEMA}
			customRenderComponents={PREVIOUS_EMAIL_ADDRESS_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function PendingEmailChangesTable({changeUIDList}) {
	return (
		<GenericTable
			incomingUIDList={changeUIDList}
			tableRenderDefinition={PENDING_EMAIL_CHANGE_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_PENDING_EMAIL_CHANGE}
			loadingContainer={PendingEmailChangeContainer}
			jsonSchema={PENDING_EMAIL_CHANGE_JSON_SCHEMA}
			customRenderComponents={PENDING_EMAIL_CHANGE_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function ArchivedPendingEmailChangesTable({changeUIDList}) {
	return (
		<GenericTable
			incomingUIDList={changeUIDList}
			tableRenderDefinition={ARCHIVED_PENDING_EMAIL_CHANGE_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_ARCHIVED_PENDING_EMAIL_CHANGE}
			loadingContainer={ArchivedPendingEmailChangeContainer}
			jsonSchema={ARCHIVED_PENDING_EMAIL_CHANGE_JSON_SCHEMA}
			customRenderComponents={ARCHIVED_PENDING_EMAIL_CHANGE_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function PasswordsTable({accountUIDList}) {
	return (
		<GenericTable
			incomingUIDList={accountUIDList}
			tableRenderDefinition={PASSWORD_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_PASSWORD}
			loadingContainer={PasswordContainer}
			jsonSchema={PASSWORD_JSON_SCHEMA}
			customRenderComponents={PASSWORD_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function ExpiredPasswordsTable({expiredPasswordUIDList}) {
	return (
		<GenericTable
			incomingUIDList={expiredPasswordUIDList}
			tableRenderDefinition={EXPIRED_PASSWORD_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_EXPIRED_PASSWORD}
			loadingContainer={ExpiredPasswordContainer}
			jsonSchema={EXPIRED_PASSWORD_JSON_SCHEMA}
			customRenderComponents={EXPIRED_PASSWORD_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function PasswordResetsTable({resetUIDList}) {
	return (
		<GenericTable
			incomingUIDList={resetUIDList}
			tableRenderDefinition={PASSWORD_RESET_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_PASSWORD_RESET}
			loadingContainer={PasswordResetContainer}
			jsonSchema={PASSWORD_RESET_JSON_SCHEMA}
			customRenderComponents={PASSWORD_RESET_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function DepositsTable({depositUIDList}) {
	return (
		<GenericTable
			incomingUIDList={depositUIDList}
			tableRenderDefinition={DEPOSIT_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_DEPOSIT}
			loadingContainer={DepositContainer}
			jsonSchema={DEPOSIT_JSON_SCHEMA}
			customRenderComponents={DEPOSIT_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function DepositInvitesTable({depositUIDList}) {
	return (
		<GenericTable
			incomingUIDList={depositUIDList}
			tableRenderDefinition={DEPOSIT_INVITE_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_DEPOSIT_INVITE}
			loadingContainer={DepositInviteContainer}
			jsonSchema={DEPOSIT_INVITE_JSON_SCHEMA}
			customRenderComponents={DEPOSIT_INVITE_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function DepositAdjustmentsTable({adjustmentUIDList}) {
	return (
		<GenericTable
			incomingUIDList={adjustmentUIDList}
			tableRenderDefinition={DEPOSIT_ADJUSTMENT_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_DEPOSIT_ADJUSTMENT}
			loadingContainer={DepositAdjustmentContainer}
			jsonSchema={DEPOSIT_ADJUSTMENT_JSON_SCHEMA}
			customRenderComponents={DEPOSIT_ADJUSTMENT_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function DepositInterestsTable({interestUIDList}) {
	return (
		<GenericTable
			incomingUIDList={interestUIDList}
			tableRenderDefinition={DEPOSIT_INTEREST_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_DEPOSIT_INTEREST}
			loadingContainer={DepositInterestContainer}
			jsonSchema={DEPOSIT_INTEREST_JSON_SCHEMA}
			customRenderComponents={DEPOSIT_INTEREST_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function DepositHistoryEntriesTable({entryUIDList}) {
	return (
		<GenericTable
			incomingUIDList={entryUIDList}
			tableRenderDefinition={DEPOSIT_HISTORY_ENTRY_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_DEPOSIT_HISTORY_ENTRY}
			loadingContainer={DepositHistoryEntryContainer}
			jsonSchema={DEPOSIT_HISTORY_ENTRY_JSON_SCHEMA}
			customRenderComponents={DEPOSIT_HISTORY_ENTRY_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function DepositCloseRequestsTable({depositUIDList}) {
	return (
		<GenericTable
			incomingUIDList={depositUIDList}
			tableRenderDefinition={DEPOSIT_CLOSE_REQUEST_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_DEPOSIT_CLOSE_REQUEST}
			loadingContainer={DepositCloseRequestContainer}
			jsonSchema={DEPOSIT_CLOSE_REQUEST_JSON_SCHEMA}
			customRenderComponents={DEPOSIT_CLOSE_REQUEST_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function DepositUserStatsTable({accountUIDList}) {
	return (
		<GenericTable
			incomingUIDList={accountUIDList}
			tableRenderDefinition={DEPOSIT_USER_STATS_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_DEPOSIT_USER_STATS}
			loadingContainer={DepositUserStatsContainer}
			jsonSchema={DEPOSIT_USER_STATS_JSON_SCHEMA}
			customRenderComponents={DEPOSIT_USER_STATS_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function DepositBankMappingsTable({mapUIDList}) {
	return (
		<GenericTable
			incomingUIDList={mapUIDList}
			tableRenderDefinition={DEPOSIT_BANK_MAPPING_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_DEPOSIT_BANK_MAPPING}
			loadingContainer={DepositBankMappingContainer}
			jsonSchema={DEPOSIT_BANK_MAPPING_JSON_SCHEMA}
			customRenderComponents={DEPOSIT_BANK_MAPPING_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function DepositBulkImportsTable({bulkImportUIDList}) {
	return (
		<GenericTable
			incomingUIDList={bulkImportUIDList}
			tableRenderDefinition={DEPOSIT_BULK_IMPORT_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_DEPOSITS_BULK_IMPORT}
			loadingContainer={DepositBulkImportContainer}
			jsonSchema={DEPOSIT_BULK_IMPORT_JSON_SCHEMA}
			customRenderComponents={DEPOSIT_BULK_IMPORT_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function DepositInterestLogsTable({entryUIDList}) {
	return (
		<GenericTable
			incomingUIDList={entryUIDList}
			tableRenderDefinition={DEPOSIT_INTEREST_LOG_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_DEPOSIT_INTEREST_LOG}
			loadingContainer={DepositInterestLogContainer}
			jsonSchema={DEPOSIT_INTEREST_LOG_JSON_SCHEMA}
			customRenderComponents={DEPOSIT_INTEREST_LOG_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function ArchivedDepositCloseRequestsTable({archiveUIDList}) {
	return (
		<GenericTable
			incomingUIDList={archiveUIDList}
			tableRenderDefinition={ARCHIVED_DEPOSIT_CLOSE_REQUEST_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_ARCHIVED_DEPOSIT_CLOSE_REQUEST}
			loadingContainer={ArchivedDepositCloseRequestContainer}
			jsonSchema={ARCHIVED_DEPOSIT_CLOSE_REQUEST_JSON_SCHEMA}
			customRenderComponents={ARCHIVED_DEPOSIT_CLOSE_REQUEST_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function DepositWithheldFundsTable({withheldUIDList}) {
	return (
		<GenericTable
			incomingUIDList={withheldUIDList}
			tableRenderDefinition={DEPOSIT_WITHHELD_FUNDS_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_DEPOSIT_WITHHELD_FUNDS}
			loadingContainer={DepositWithheldFundsContainer}
			jsonSchema={DEPOSIT_WITHHELD_FUNDS_JSON_SCHEMA}
			customRenderComponents={DEPOSIT_WITHHELD_FUNDS_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function PmcReportTimetablesTable({timetableUIDList}) {
	return (
		<GenericTable
			incomingUIDList={timetableUIDList}
			tableRenderDefinition={PMC_REPORT_TIMETABLE_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_PMC_REPORT_TIMETABLE}
			loadingContainer={PMCReportTimetableContainer}
			jsonSchema={PMC_REPORT_TIMETABLE_JSON_SCHEMA}
			customRenderComponents={PMC_REPORT_TIMETABLE_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function DepositGroupsTable({groupUIDList}) {
	return (
		<GenericTable
			incomingUIDList={groupUIDList}
			tableRenderDefinition={DEPOSIT_GROUP_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_DEPOSIT_GROUP}
			loadingContainer={DepositGroupContainer}
			jsonSchema={DEPOSIT_GROUP_JSON_SCHEMA}
			customRenderComponents={DEPOSIT_GROUP_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function DepositPostCloseAdjustmentsTable({adjustmentUIDList}) {
	return (
		<GenericTable
			incomingUIDList={adjustmentUIDList}
			tableRenderDefinition={DEPOSIT_POST_CLOSE_ADJUSTMENT_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_DEPOSIT_POST_CLOSE_ADJUSTMENT}
			loadingContainer={DepositPostCloseAdjustmentContainer}
			jsonSchema={DEPOSIT_POST_CLOSE_ADJUSTMENT_JSON_SCHEMA}
			customRenderComponents={DEPOSIT_POST_CLOSE_ADJUSTMENT_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function DepositUserGroupsTable({depositUIDList}) {
	return (
		<GenericTable
			incomingUIDList={depositUIDList}
			tableRenderDefinition={DEPOSIT_USER_GROUP_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_DEPOSIT_USER_GROUP}
			loadingContainer={DepositUserGroupContainer}
			jsonSchema={DEPOSIT_USER_GROUP_JSON_SCHEMA}
			customRenderComponents={DEPOSIT_USER_GROUP_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function PropertyGroupsTable({groupUIDList}) {
	return (
		<GenericTable
			incomingUIDList={groupUIDList}
			tableRenderDefinition={PROPERTY_GROUP_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_PROPERTY_GROUP}
			loadingContainer={PropertyGroupContainer}
			jsonSchema={PROPERTY_GROUP_JSON_SCHEMA}
			customRenderComponents={PROPERTY_GROUP_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function PropertyUserGroupsTable({propertyUIDList}) {
	return (
		<GenericTable
			incomingUIDList={propertyUIDList}
			tableRenderDefinition={PROPERTY_USER_GROUP_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_PROPERTY_USER_GROUP}
			loadingContainer={PropertyUserGroupContainer}
			jsonSchema={PROPERTY_USER_GROUP_JSON_SCHEMA}
			customRenderComponents={PROPERTY_USER_GROUP_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function DisputesTable({disputeUIDList}) {
	return (
		<GenericTable
			incomingUIDList={disputeUIDList}
			tableRenderDefinition={DISPUTE_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_DISPUTE}
			loadingContainer={DisputeContainer}
			jsonSchema={DISPUTE_JSON_SCHEMA}
			customRenderComponents={DISPUTE_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function DisputeSplitsTable({splitUIDList}) {
	return (
		<GenericTable
			incomingUIDList={splitUIDList}
			tableRenderDefinition={DISPUTE_SPLIT_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_DISPUTE_SPLIT}
			loadingContainer={DisputeSplitContainer}
			jsonSchema={DISPUTE_SPLIT_JSON_SCHEMA}
			customRenderComponents={DISPUTE_SPLIT_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function DisputeInterventionRequestsTable({requestUIDList}) {
	return (
		<GenericTable
			incomingUIDList={requestUIDList}
			tableRenderDefinition={DISPUTE_INTERVENTION_REQUEST_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_DISPUTE_INTERVENTION_REQUEST}
			loadingContainer={DisputeInterventionRequestContainer}
			jsonSchema={DISPUTE_INTERVENTION_REQUEST_JSON_SCHEMA}
			customRenderComponents={DISPUTE_INTERVENTION_REQUEST_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function PropertiesTable({propertyUIDList}) {
	return (
		<GenericTable
			incomingUIDList={propertyUIDList}
			tableRenderDefinition={PROPERTY_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_PROPERTY}
			loadingContainer={PropertyContainer}
			jsonSchema={PROPERTY_JSON_SCHEMA}
			customRenderComponents={PROPERTY_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function PropertyAddressesTable({propertyAddressUIDList}) {
	return (
		<GenericTable
			incomingUIDList={propertyAddressUIDList}
			tableRenderDefinition={PROPERTY_ADDRESS_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_PROPERTY_ADDRESS}
			loadingContainer={PropertyAddressContainer}
			jsonSchema={PROPERTY_ADDRESS_JSON_SCHEMA}
			customRenderComponents={PROPERTY_ADDRESS_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function CompliancesTable({complianceUIDList}) {
	return (
		<GenericTable
			incomingUIDList={complianceUIDList}
			tableRenderDefinition={COMPLIANCE_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_COMPLIANCE}
			loadingContainer={ComplianceContainer}
			jsonSchema={COMPLIANCE_JSON_SCHEMA}
			customRenderComponents={COMPLIANCE_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function ComplianceRuleTable({complianceRuleUIDList}) {
	return (
		<GenericTable
			incomingUIDList={complianceRuleUIDList}
			tableRenderDefinition={COMPLIANCE_RULE_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_COMPLIANCE_RULE}
			loadingContainer={ComplianceRuleContainer}
			jsonSchema={COMPLIANCE_RULE_JSON_SCHEMA}
			customRenderComponents={COMPLIANCE_RULE_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function ComplianceHistoriesTable({complianceHistoryUIDList}) {
	return (
		<GenericTable
			incomingUIDList={complianceHistoryUIDList}
			tableRenderDefinition={COMPLIANCE_HISTORY_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_COMPLIANCE_HISTORY}
			loadingContainer={ComplianceHistoryContainer}
			jsonSchema={COMPLIANCE_HISTORY_JSON_SCHEMA}
			customRenderComponents={COMPLIANCE_HISTORY_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function EmailTemplatesTable({templateUIDList}) {
	return (
		<GenericTable
			incomingUIDList={templateUIDList}
			tableRenderDefinition={EMAIL_TEMPLATE_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_EMAIL_TEMPLATE}
			loadingContainer={EmailTemplateContainer}
			jsonSchema={EMAIL_TEMPLATE_JSON_SCHEMA}
			customRenderComponents={EMAIL_TEMPLATE_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function EmailVerificationsTable({verificationUIDList}) {
	return (
		<GenericTable
			incomingUIDList={verificationUIDList}
			tableRenderDefinition={EMAIL_VERIFICATION_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_EMAIL_VERIFICATION}
			loadingContainer={EmailVerificationContainer}
			jsonSchema={EMAIL_VERIFICATION_JSON_SCHEMA}
			customRenderComponents={EMAIL_VERIFICATION_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function EmailVerificationRecordsTable({verificationUIDList}) {
	return (
		<GenericTable
			incomingUIDList={verificationUIDList}
			tableRenderDefinition={EMAIL_VERIFICATION_RECORD_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_EMAIL_VERIFICATION_RECORD}
			loadingContainer={EmailVerificationRecordContainer}
			jsonSchema={EMAIL_VERIFICATION_RECORD_JSON_SCHEMA}
			customRenderComponents={EMAIL_VERIFICATION_RECORD_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function EmailEventsTable({eventUIDList}) {
	return (
		<GenericTable
			incomingUIDList={eventUIDList}
			tableRenderDefinition={EMAIL_EVENT_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_EMAIL_EVENT}
			loadingContainer={EmailEventContainer}
			jsonSchema={EMAIL_EVENT_JSON_SCHEMA}
			customRenderComponents={EMAIL_EVENT_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function SentEmailsTable({emailUIDList}) {
	return (
		<GenericTable
			incomingUIDList={emailUIDList}
			tableRenderDefinition={SENT_EMAIL_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_SENT_EMAIL}
			loadingContainer={SentEmailContainer}
			jsonSchema={SENT_EMAIL_JSON_SCHEMA}
			customRenderComponents={SENT_EMAIL_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function MailboxesTable({mailboxUIDList}) {
	return (
		<GenericTable
			incomingUIDList={mailboxUIDList}
			tableRenderDefinition={MAILBOX_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_MAILBOX}
			loadingContainer={MailboxContainer}
			jsonSchema={MAILBOX_JSON_SCHEMA}
			customRenderComponents={MAILBOX_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function MailboxMetaDataTable({metaDataUIDList}) {
	return (
		<GenericTable
			incomingUIDList={metaDataUIDList}
			tableRenderDefinition={MAILBOX_META_DATA_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_MAILBOX_META_DATA}
			loadingContainer={MailboxMetaDataContainer}
			jsonSchema={MAILBOX_META_DATA_JSON_SCHEMA}
			customRenderComponents={MAILBOX_META_DATA_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function MailboxMessagesTable({messageUIDList}) {
	return (
		<GenericTable
			incomingUIDList={messageUIDList}
			tableRenderDefinition={MAILBOX_MESSAGE_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_MAILBOX_MESSAGE}
			loadingContainer={MailboxMessageContainer}
			jsonSchema={MAILBOX_MESSAGE_JSON_SCHEMA}
			customRenderComponents={MAILBOX_MESSAGE_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function PermissionEntriesTable({permissionUIDList}) {
	return (
		<GenericTable
			incomingUIDList={permissionUIDList}
			tableRenderDefinition={PERMISSION_ENTRY_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_PERMISSION_ENTRY}
			loadingContainer={PermissionEntryContainer}
			jsonSchema={PERMISSION_ENTRY_JSON_SCHEMA}
			customRenderComponents={PERMISSION_ENTRY_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function PermissionLogEntriesTable({logEntryUIDList}) {
	return (
		<GenericTable
			incomingUIDList={logEntryUIDList}
			tableRenderDefinition={PERMISSION_LOG_ENTRY_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_PERMISSION_LOG_ENTRY}
			loadingContainer={PermissionLogEntryContainer}
			jsonSchema={PERMISSION_LOG_ENTRY_JSON_SCHEMA}
			customRenderComponents={PERMISSION_LOG_ENTRY_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function PermissionsOrganizationSettingsTable({organizationUIDList}) {
	return (
		<GenericTable
			incomingUIDList={organizationUIDList}
			tableRenderDefinition={PERMISSIONS_ORGANIZATION_SETTINGS_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_PERMISSIONS_ORGANIZATION_SETTINGS}
			loadingContainer={PermissionsOrganizationSettingsContainer}
			jsonSchema={PERMISSIONS_ORGANIZATION_SETTINGS_JSON_SCHEMA}
			customRenderComponents={PERMISSIONS_ORGANIZATION_SETTINGS_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function ResourcePermissionsTable({permissionUIDList}) {
	return (
		<GenericTable
			incomingUIDList={permissionUIDList}
			tableRenderDefinition={RESOURCE_PERMISSION_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_RESOURCE_PERMISSIONS}
			loadingContainer={ResourcePermissionContainer}
			jsonSchema={RESOURCE_PERMISSION_JSON_SCHEMA}
			customRenderComponents={RESOURCE_PERMISSION_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function OrganizationsTable({organizationUIDList}) {
	return (
		<GenericTable
			incomingUIDList={organizationUIDList}
			tableRenderDefinition={ORGANIZATION_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_ORGANIZATION}
			loadingContainer={OrganizationContainer}
			jsonSchema={ORGANIZATION_JSON_SCHEMA}
			customRenderComponents={ORGANIZATION_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function OrganizationResourcePermissionRulesTable({ruleUIDList}) {
	return (
		<GenericTable
			incomingUIDList={ruleUIDList}
			tableRenderDefinition={ORGANIZATION_RESOURCE_PERMISSION_RULE_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_ORGANIZATION_RESOURCE_PERMISSION_RULE}
			loadingContainer={OrganizationResourcePermissionRuleContainer}
			jsonSchema={ORGANIZATION_RESOURCE_PERMISSION_RULE_JSON_SCHEMA}
			customRenderComponents={ORGANIZATION_RESOURCE_PERMISSION_RULE_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function InvoicesTable({invoiceUIDList}) {
	return (
		<GenericTable
			incomingUIDList={invoiceUIDList}
			tableRenderDefinition={INVOICE_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_INVOICE}
			loadingContainer={InvoiceContainer}
			jsonSchema={INVOICE_JSON_SCHEMA}
			customRenderComponents={INVOICE_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function InvoiceItemsTable({invoiceItemUIDList}) {
	return (
		<GenericTable
			incomingUIDList={invoiceItemUIDList}
			tableRenderDefinition={INVOICE_ITEM_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_INVOICE_ITEM}
			loadingContainer={InvoiceItemContainer}
			jsonSchema={INVOICE_ITEM_JSON_SCHEMA}
			customRenderComponents={INVOICE_ITEM_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function PaymentRequestsTable({requestUIDList}) {
	return (
		<GenericTable
			incomingUIDList={requestUIDList}
			tableRenderDefinition={PAYMENT_REQUEST_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_PAYMENT_REQUEST}
			loadingContainer={PaymentRequestContainer}
			jsonSchema={PAYMENT_REQUEST_JSON_SCHEMA}
			customRenderComponents={PAYMENT_REQUEST_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function StripePaymentLogsTable({paymentLogUIDList}) {
	return (
		<GenericTable
			incomingUIDList={paymentLogUIDList}
			tableRenderDefinition={STRIPE_PAYMENT_LOG_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_STRIPE_PAYMENT_LOG}
			loadingContainer={StripePaymentLogContainer}
			jsonSchema={STRIPE_PAYMENT_LOG_JSON_SCHEMA}
			customRenderComponents={STRIPE_PAYMENT_LOG_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function UserWithdrawsTable({withdrawUIDList}) {
	return (
		<GenericTable
			incomingUIDList={withdrawUIDList}
			tableRenderDefinition={USER_WITHDRAW_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_USER_WITHDRAW}
			loadingContainer={UserWithdrawContainer}
			jsonSchema={USER_WITHDRAW_JSON_SCHEMA}
			customRenderComponents={USER_WITHDRAW_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function PriorityAchPaymentsTable({paymentUIDList}) {
	return (
		<GenericTable
			incomingUIDList={paymentUIDList}
			tableRenderDefinition={PRIORITY_ACH_PAYMENT_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_PRIORITY_ACH_PAYMENT}
			loadingContainer={PriorityACHPaymentContainer}
			jsonSchema={PRIORITY_ACH_PAYMENT_JSON_SCHEMA}
			customRenderComponents={PRIORITY_ACH_PAYMENT_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function PriorityAchRecurringPaymentsTable({recurringPaymentUIDList}) {
	return (
		<GenericTable
			incomingUIDList={recurringPaymentUIDList}
			tableRenderDefinition={PRIORITY_ACH_RECURRING_PAYMENT_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_PRIORITY_ACH_RECURRING_PAYMENT}
			loadingContainer={PriorityACHRecurringPaymentContainer}
			jsonSchema={PRIORITY_ACH_RECURRING_PAYMENT_JSON_SCHEMA}
			customRenderComponents={PRIORITY_ACH_RECURRING_PAYMENT_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function LoanApplicationsTable({applicationUIDList}) {
	return (
		<GenericTable
			incomingUIDList={applicationUIDList}
			tableRenderDefinition={LOAN_APPLICATION_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_LOAN_APPLICATION}
			loadingContainer={LoanApplicationContainer}
			jsonSchema={LOAN_APPLICATION_JSON_SCHEMA}
			customRenderComponents={LOAN_APPLICATION_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function LoanSystemInfosTable({loanInfoUIDList}) {
	return (
		<GenericTable
			incomingUIDList={loanInfoUIDList}
			tableRenderDefinition={LOAN_SYSTEM_INFO_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_LOAN_SYSTEM_INFO}
			loadingContainer={LoanSystemInfoContainer}
			jsonSchema={LOAN_SYSTEM_INFO_JSON_SCHEMA}
			customRenderComponents={LOAN_SYSTEM_INFO_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function LoansTable({loanUIDList}) {
	return (
		<GenericTable
			incomingUIDList={loanUIDList}
			tableRenderDefinition={LOAN_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_LOAN}
			loadingContainer={LoanContainer}
			jsonSchema={LOAN_JSON_SCHEMA}
			customRenderComponents={LOAN_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function HistoryEntriesTable({loanUIDList}) {
	return (
		<GenericTable
			incomingUIDList={loanUIDList}
			tableRenderDefinition={LOAN_HISTORY_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_LOAN_HISTORY}
			loadingContainer={LoanHistoryContainer}
			jsonSchema={LOAN_HISTORY_JSON_SCHEMA}
			customRenderComponents={LOAN_HISTORY_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function LoanPaymentLogsTable({logUIDList}) {
	return (
		<GenericTable
			incomingUIDList={logUIDList}
			tableRenderDefinition={LOAN_PAYMENT_LOG_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_LOAN_PAYMENT_LOG}
			loadingContainer={LoanPaymentLogContainer}
			jsonSchema={LOAN_PAYMENT_LOG_JSON_SCHEMA}
			customRenderComponents={LOAN_PAYMENT_LOG_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function LogEntriesTable({logUIDList}) {
	return (
		<GenericTable
			incomingUIDList={logUIDList}
			tableRenderDefinition={STRIPE_WEBHOOK_LOG_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_STRIPE_WEBHOOK_LOG}
			loadingContainer={StripeWebhookLogContainer}
			jsonSchema={STRIPE_WEBHOOK_LOG_JSON_SCHEMA}
			customRenderComponents={STRIPE_WEBHOOK_LOG_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function InfoTable({accountUIDList}) {
	return (
		<GenericTable
			incomingUIDList={accountUIDList}
			tableRenderDefinition={USER_ACCOUNT_PAYMENT_PROVIDER_INFO_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_USER_ACCOUNT_PAYMENT_PROVIDER_INFO}
			loadingContainer={UserAccountPaymentProviderInfoContainer}
			jsonSchema={USER_ACCOUNT_PAYMENT_PROVIDER_INFO_JSON_SCHEMA}
			customRenderComponents={USER_ACCOUNT_PAYMENT_PROVIDER_INFO_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function SezzleOrdersTable({sezzleOrderUIDList}) {
	return (
		<GenericTable
			incomingUIDList={sezzleOrderUIDList}
			tableRenderDefinition={SEZZLE_ORDER_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_SEZZLE_ORDER}
			loadingContainer={SezzleOrderContainer}
			jsonSchema={SEZZLE_ORDER_JSON_SCHEMA}
			customRenderComponents={SEZZLE_ORDER_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function SezzleWebhookEventsTable({eventUIDList}) {
	return (
		<GenericTable
			incomingUIDList={eventUIDList}
			tableRenderDefinition={SEZZLE_WEBHOOK_EVENT_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_SEZZLE_WEBHOOK_EVENT}
			loadingContainer={SezzleWebhookEventContainer}
			jsonSchema={SEZZLE_WEBHOOK_EVENT_JSON_SCHEMA}
			customRenderComponents={SEZZLE_WEBHOOK_EVENT_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function BankAccountsTable({bankAccountUIDList}) {
	return (
		<GenericTable
			incomingUIDList={bankAccountUIDList}
			tableRenderDefinition={BANK_ACCOUNT_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_BANK_ACCOUNT}
			loadingContainer={BankAccountContainer}
			jsonSchema={BANK_ACCOUNT_JSON_SCHEMA}
			customRenderComponents={BANK_ACCOUNT_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function BankAccountHistoricalInterestRatesTable({rateHistoryUIDList}) {
	return (
		<GenericTable
			incomingUIDList={rateHistoryUIDList}
			tableRenderDefinition={BANK_ACCOUNT_HISTORICAL_INTEREST_RATE_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_BANK_ACCOUNT_HISTORICAL_INTEREST_RATE}
			loadingContainer={BankAccountHistoricalInterestRateContainer}
			jsonSchema={BANK_ACCOUNT_HISTORICAL_INTEREST_RATE_JSON_SCHEMA}
			customRenderComponents={BANK_ACCOUNT_HISTORICAL_INTEREST_RATE_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function BankAccountInterestsTable({interestUIDList}) {
	return (
		<GenericTable
			incomingUIDList={interestUIDList}
			tableRenderDefinition={BANK_ACCOUNT_INTEREST_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_BANK_ACCOUNT_INTEREST}
			loadingContainer={BankAccountInterestContainer}
			jsonSchema={BANK_ACCOUNT_INTEREST_JSON_SCHEMA}
			customRenderComponents={BANK_ACCOUNT_INTEREST_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function BankAccountBalanceRecordsTable({recordUIDList}) {
	return (
		<GenericTable
			incomingUIDList={recordUIDList}
			tableRenderDefinition={BANK_ACCOUNT_BALANCE_RECORD_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_BANK_ACCOUNT_BALANCE_RECORD}
			loadingContainer={BankAccountBalanceRecordContainer}
			jsonSchema={BANK_ACCOUNT_BALANCE_RECORD_JSON_SCHEMA}
			customRenderComponents={BANK_ACCOUNT_BALANCE_RECORD_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function BankTransfersTable({transferUIDList}) {
	return (
		<GenericTable
			incomingUIDList={transferUIDList}
			tableRenderDefinition={BANK_TRANSFER_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_BANK_TRANSFER}
			loadingContainer={BankTransferContainer}
			jsonSchema={BANK_TRANSFER_JSON_SCHEMA}
			customRenderComponents={BANK_TRANSFER_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function BulkFundsTransfersTable({bulkTransferUIDList}) {
	return (
		<GenericTable
			incomingUIDList={bulkTransferUIDList}
			tableRenderDefinition={BULK_FUNDS_TRANSFER_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_BULK_FUNDS_TRANSFER}
			loadingContainer={BulkFundsTransferContainer}
			jsonSchema={BULK_FUNDS_TRANSFER_JSON_SCHEMA}
			customRenderComponents={BULK_FUNDS_TRANSFER_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function FundsLocksTable({lockUIDList}) {
	return (
		<GenericTable
			incomingUIDList={lockUIDList}
			tableRenderDefinition={FUNDS_LOCK_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_FUNDS_LOCK}
			loadingContainer={FundsLockContainer}
			jsonSchema={FUNDS_LOCK_JSON_SCHEMA}
			customRenderComponents={FUNDS_LOCK_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function FundsLockReleaseLogsTable({releaseLogUIDList}) {
	return (
		<GenericTable
			incomingUIDList={releaseLogUIDList}
			tableRenderDefinition={FUNDS_LOCK_RELEASE_LOG_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_FUNDS_LOCK_RELEASE_LOG}
			loadingContainer={FundsLockReleaseLogContainer}
			jsonSchema={FUNDS_LOCK_RELEASE_LOG_JSON_SCHEMA}
			customRenderComponents={FUNDS_LOCK_RELEASE_LOG_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function ReleasedFundsLocksTable({lockUIDList}) {
	return (
		<GenericTable
			incomingUIDList={lockUIDList}
			tableRenderDefinition={RELEASED_FUNDS_LOCK_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_RELEASED_FUNDS_LOCK}
			loadingContainer={ReleasedFundsLockContainer}
			jsonSchema={RELEASED_FUNDS_LOCK_JSON_SCHEMA}
			customRenderComponents={RELEASED_FUNDS_LOCK_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function BalanceSourceTransfersTable({transferUIDList}) {
	return (
		<GenericTable
			incomingUIDList={transferUIDList}
			tableRenderDefinition={BALANCE_SOURCE_TRANSFER_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_BALANCE_SOURCE_TRANSFER}
			loadingContainer={BalanceSourceTransferContainer}
			jsonSchema={BALANCE_SOURCE_TRANSFER_JSON_SCHEMA}
			customRenderComponents={BALANCE_SOURCE_TRANSFER_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function CreditUserAccountLogsTable({creditLogUIDList}) {
	return (
		<GenericTable
			incomingUIDList={creditLogUIDList}
			tableRenderDefinition={CREDIT_USER_ACCOUNT_LOG_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_CREDIT_USER_ACCOUNT_LOG}
			loadingContainer={CreditUserAccountLogContainer}
			jsonSchema={CREDIT_USER_ACCOUNT_LOG_JSON_SCHEMA}
			customRenderComponents={CREDIT_USER_ACCOUNT_LOG_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function EventsTable({eventUIDList}) {
	return (
		<GenericTable
			incomingUIDList={eventUIDList}
			tableRenderDefinition={EVENT_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_EVENT}
			loadingContainer={EventContainer}
			jsonSchema={EVENT_JSON_SCHEMA}
			customRenderComponents={EVENT_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function EventHooksTable({hookUIDList}) {
	return (
		<GenericTable
			incomingUIDList={hookUIDList}
			tableRenderDefinition={EVENT_HOOK_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_EVENT_HOOK}
			loadingContainer={EventHookContainer}
			jsonSchema={EVENT_HOOK_JSON_SCHEMA}
			customRenderComponents={EVENT_HOOK_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function NotificationsTable({notificationUIDList}) {
	return (
		<GenericTable
			incomingUIDList={notificationUIDList}
			tableRenderDefinition={NOTIFICATION_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_NOTIFICATION}
			loadingContainer={NotificationContainer}
			jsonSchema={NOTIFICATION_JSON_SCHEMA}
			customRenderComponents={NOTIFICATION_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function ActionItemsTable({itemUIDList}) {
	return (
		<GenericTable
			incomingUIDList={itemUIDList}
			tableRenderDefinition={ACTION_ITEM_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_ACTION_ITEM}
			loadingContainer={ActionItemContainer}
			jsonSchema={ACTION_ITEM_JSON_SCHEMA}
			customRenderComponents={ACTION_ITEM_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function UpdateLogsTable({entryUIDList}) {
	return (
		<GenericTable
			incomingUIDList={entryUIDList}
			tableRenderDefinition={UPDATE_LOG_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_UPDATE_LOG_ENTRY}
			loadingContainer={UpdateLogContainer}
			jsonSchema={UPDATE_LOG_JSON_SCHEMA}
			customRenderComponents={UPDATE_LOG_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function StorageFilesTable({fileUIDList}) {
	return (
		<GenericTable
			incomingUIDList={fileUIDList}
			tableRenderDefinition={STORAGE_FILE_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_STORAGE_FILE}
			loadingContainer={StorageFileContainer}
			jsonSchema={STORAGE_FILE_JSON_SCHEMA}
			customRenderComponents={STORAGE_FILE_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function AttachedStorageFilesTable({attachedFilesUIDList}) {
	return (
		<GenericTable
			incomingUIDList={attachedFilesUIDList}
			tableRenderDefinition={ATTACHED_STORAGE_FILES_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_ATTACHED_STORAGE_FILES}
			loadingContainer={AttachedStorageFilesContainer}
			jsonSchema={ATTACHED_STORAGE_FILES_JSON_SCHEMA}
			customRenderComponents={ATTACHED_STORAGE_FILES_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function SystemHistoryEntriesTable({entryUIDList}) {
	return (
		<GenericTable
			incomingUIDList={entryUIDList}
			tableRenderDefinition={SYSTEM_HISTORY_ENTRY_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_SYSTEM_HISTORY_ENTRY}
			loadingContainer={SystemHistoryEntryContainer}
			jsonSchema={SYSTEM_HISTORY_ENTRY_JSON_SCHEMA}
			customRenderComponents={SYSTEM_HISTORY_ENTRY_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function SnapshotsTable({snapshotUIDList}) {
	return (
		<GenericTable
			incomingUIDList={snapshotUIDList}
			tableRenderDefinition={SNAPSHOT_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_SNAPSHOT}
			loadingContainer={SnapshotContainer}
			jsonSchema={SNAPSHOT_JSON_SCHEMA}
			customRenderComponents={SNAPSHOT_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function IpAddressesTable({ipUIDList}) {
	return (
		<GenericTable
			incomingUIDList={ipUIDList}
			tableRenderDefinition={IP_ADDRESS_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_IP_ADDRESS}
			loadingContainer={IPAddressContainer}
			jsonSchema={IP_ADDRESS_JSON_SCHEMA}
			customRenderComponents={IP_ADDRESS_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function KnownIpAddressesTable({knownIpUIDList}) {
	return (
		<GenericTable
			incomingUIDList={knownIpUIDList}
			tableRenderDefinition={KNOWN_IP_ADDRESS_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_KNOWN_IP_ADDRESS}
			loadingContainer={KnownIPAddressContainer}
			jsonSchema={KNOWN_IP_ADDRESS_JSON_SCHEMA}
			customRenderComponents={KNOWN_IP_ADDRESS_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function UserAgentsTable({userAgentUIDList}) {
	return (
		<GenericTable
			incomingUIDList={userAgentUIDList}
			tableRenderDefinition={USER_AGENT_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_USER_AGENT}
			loadingContainer={UserAgentContainer}
			jsonSchema={USER_AGENT_JSON_SCHEMA}
			customRenderComponents={USER_AGENT_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function KnownUserAgentsTable({knownUserAgentUIDList}) {
	return (
		<GenericTable
			incomingUIDList={knownUserAgentUIDList}
			tableRenderDefinition={KNOWN_USER_AGENT_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_KNOWN_USER_AGENT}
			loadingContainer={KnownUserAgentContainer}
			jsonSchema={KNOWN_USER_AGENT_JSON_SCHEMA}
			customRenderComponents={KNOWN_USER_AGENT_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function SystemStatsTable({statsUIDList}) {
	return (
		<GenericTable
			incomingUIDList={statsUIDList}
			tableRenderDefinition={SYSTEM_STATS_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_SYSTEM_STATS}
			loadingContainer={SystemStatsContainer}
			jsonSchema={SYSTEM_STATS_JSON_SCHEMA}
			customRenderComponents={SYSTEM_STATS_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function ResourceNoteTable({notesUIDList}) {
	return (
		<GenericTable
			incomingUIDList={notesUIDList}
			tableRenderDefinition={RESOURCE_NOTE_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_RESOURCE_NOTE}
			loadingContainer={ResourceNoteContainer}
			jsonSchema={RESOURCE_NOTE_JSON_SCHEMA}
			customRenderComponents={RESOURCE_NOTE_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function DeposifyTagsTable({tagUIDList}) {
	return (
		<GenericTable
			incomingUIDList={tagUIDList}
			tableRenderDefinition={DEPOSIFY_TAG_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_DEPOSIFY_TAG}
			loadingContainer={DeposifyTagContainer}
			jsonSchema={DEPOSIFY_TAG_JSON_SCHEMA}
			customRenderComponents={DEPOSIFY_TAG_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function LinksTable({linkUIDList}) {
	return (
		<GenericTable
			incomingUIDList={linkUIDList}
			tableRenderDefinition={PERMANENT_LINK_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_PERMANENT_LINK}
			loadingContainer={PermanentLinkContainer}
			jsonSchema={PERMANENT_LINK_JSON_SCHEMA}
			customRenderComponents={PERMANENT_LINK_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function OnlineUsersTable({onlineUserUIDList}) {
	return (
		<GenericTable
			incomingUIDList={onlineUserUIDList}
			tableRenderDefinition={ONLINE_USER_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_ONLINE_USER}
			loadingContainer={OnlineUserContainer}
			jsonSchema={ONLINE_USER_JSON_SCHEMA}
			customRenderComponents={ONLINE_USER_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function FrontendGeneralSettingsTable({settingsUIDList}) {
	return (
		<GenericTable
			incomingUIDList={settingsUIDList}
			tableRenderDefinition={FRONTEND_GENERAL_SETTINGS_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_FRONTEND_GENERAL_SETTINGS}
			loadingContainer={FrontendGeneralSettingsContainer}
			jsonSchema={FRONTEND_GENERAL_SETTINGS_JSON_SCHEMA}
			customRenderComponents={FRONTEND_GENERAL_SETTINGS_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function YardiScreeningWorksProXmlTable({xmlUIDList}) {
	return (
		<GenericTable
			incomingUIDList={xmlUIDList}
			tableRenderDefinition={YARDI_SCREENING_WORKS_PRO_XML_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_YARDI_SCREENING_WORKS_PRO_XML}
			loadingContainer={YardiScreeningWorksProXMLContainer}
			jsonSchema={YARDI_SCREENING_WORKS_PRO_XML_JSON_SCHEMA}
			customRenderComponents={YARDI_SCREENING_WORKS_PRO_XML_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function YardiVoyagerXmlTable({voyagerXmlUIDList}) {
	return (
		<GenericTable
			incomingUIDList={voyagerXmlUIDList}
			tableRenderDefinition={YARDI_VOYAGER_XML_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_XML}
			loadingContainer={YardiVoyagerXMLContainer}
			jsonSchema={YARDI_VOYAGER_XML_JSON_SCHEMA}
			customRenderComponents={YARDI_VOYAGER_XML_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function YardiVoyagerTransactionsTable({voyagerTransactionUIDList}) {
	return (
		<GenericTable
			incomingUIDList={voyagerTransactionUIDList}
			tableRenderDefinition={YARDI_VOYAGER_TRANSACTION_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_TRANSACTION}
			loadingContainer={YardiVoyagerTransactionContainer}
			jsonSchema={YARDI_VOYAGER_TRANSACTION_JSON_SCHEMA}
			customRenderComponents={YARDI_VOYAGER_TRANSACTION_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function YardiVoyagerResidentsTable({voyagerResidentUIDList}) {
	return (
		<GenericTable
			incomingUIDList={voyagerResidentUIDList}
			tableRenderDefinition={YARDI_VOYAGER_RESIDENT_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT}
			loadingContainer={YardiVoyagerResidentContainer}
			jsonSchema={YARDI_VOYAGER_RESIDENT_JSON_SCHEMA}
			customRenderComponents={YARDI_VOYAGER_RESIDENT_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function YardiVoyagerResidentCustomColumnsTable({customColumnUIDList}) {
	return (
		<GenericTable
			incomingUIDList={customColumnUIDList}
			tableRenderDefinition={YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN}
			loadingContainer={YardiVoyagerResidentCustomColumnContainer}
			jsonSchema={YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN_JSON_SCHEMA}
			customRenderComponents={YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function YardiVoyagerPropertyUnitsTable({voyagerPropertyUnitUIDList}) {
	return (
		<GenericTable
			incomingUIDList={voyagerPropertyUnitUIDList}
			tableRenderDefinition={YARDI_VOYAGER_PROPERTY_UNIT_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY_UNIT}
			loadingContainer={YardiVoyagerPropertyUnitContainer}
			jsonSchema={YARDI_VOYAGER_PROPERTY_UNIT_JSON_SCHEMA}
			customRenderComponents={YARDI_VOYAGER_PROPERTY_UNIT_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function YardiVoyagerPropertiesTable({voyagerPropertyUIDList}) {
	return (
		<GenericTable
			incomingUIDList={voyagerPropertyUIDList}
			tableRenderDefinition={YARDI_VOYAGER_PROPERTY_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY}
			loadingContainer={YardiVoyagerPropertyContainer}
			jsonSchema={YARDI_VOYAGER_PROPERTY_JSON_SCHEMA}
			customRenderComponents={YARDI_VOYAGER_PROPERTY_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function YardiVoyagerPmcServiceInterfaceVersionsTable({serviceInterfaceVersionUIDList}) {
	return (
		<GenericTable
			incomingUIDList={serviceInterfaceVersionUIDList}
			tableRenderDefinition={YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION}
			loadingContainer={YardiVoyagerPMCServiceInterfaceVersionContainer}
			jsonSchema={YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION_JSON_SCHEMA}
			customRenderComponents={YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function YardiVoyagerPmcsTable({deposifyPmcAccountUIDList}) {
	return (
		<GenericTable
			incomingUIDList={deposifyPmcAccountUIDList}
			tableRenderDefinition={YARDI_VOYAGER_PMC_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PMC}
			loadingContainer={YardiVoyagerPMCContainer}
			jsonSchema={YARDI_VOYAGER_PMC_JSON_SCHEMA}
			customRenderComponents={YARDI_VOYAGER_PMC_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function YardiVoyagerPmcCredentialsTable({deposifyPmcAccountUIDList}) {
	return (
		<GenericTable
			incomingUIDList={deposifyPmcAccountUIDList}
			tableRenderDefinition={YARDI_VOYAGER_PMC_CREDENTIALS_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PMC_CREDENTIALS}
			loadingContainer={YardiVoyagerPMCCredentialsContainer}
			jsonSchema={YARDI_VOYAGER_PMC_CREDENTIALS_JSON_SCHEMA}
			customRenderComponents={YARDI_VOYAGER_PMC_CREDENTIALS_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function YardiVoyagerPetsTable({petUIDList}) {
	return (
		<GenericTable
			incomingUIDList={petUIDList}
			tableRenderDefinition={YARDI_VOYAGER_PET_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PET}
			loadingContainer={YardiVoyagerPetContainer}
			jsonSchema={YARDI_VOYAGER_PET_JSON_SCHEMA}
			customRenderComponents={YARDI_VOYAGER_PET_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function YardiVoyagerIlsGuestCardEventsTable({guestCardEventUIDList}) {
	return (
		<GenericTable
			incomingUIDList={guestCardEventUIDList}
			tableRenderDefinition={YARDI_VOYAGER_ILS_GUEST_CARD_EVENT_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_ILS_GUEST_CARD_EVENT}
			loadingContainer={YardiVoyagerILSGuestCardEventContainer}
			jsonSchema={YARDI_VOYAGER_ILS_GUEST_CARD_EVENT_JSON_SCHEMA}
			customRenderComponents={YARDI_VOYAGER_ILS_GUEST_CARD_EVENT_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function YardiVoyagerChargesTable({voyagerChargeUIDList}) {
	return (
		<GenericTable
			incomingUIDList={voyagerChargeUIDList}
			tableRenderDefinition={YARDI_VOYAGER_CHARGE_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_CHARGE}
			loadingContainer={YardiVoyagerChargeContainer}
			jsonSchema={YARDI_VOYAGER_CHARGE_JSON_SCHEMA}
			customRenderComponents={YARDI_VOYAGER_CHARGE_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function YardiVoyagerChargeCodesTable({chargeCodeUIDList}) {
	return (
		<GenericTable
			incomingUIDList={chargeCodeUIDList}
			tableRenderDefinition={YARDI_VOYAGER_CHARGE_CODE_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_CHARGE_CODE}
			loadingContainer={YardiVoyagerChargeCodeContainer}
			jsonSchema={YARDI_VOYAGER_CHARGE_CODE_JSON_SCHEMA}
			customRenderComponents={YARDI_VOYAGER_CHARGE_CODE_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function YardiVoyagerDepositCreateIntentsTable({createIntentUIDList}) {
	return (
		<GenericTable
			incomingUIDList={createIntentUIDList}
			tableRenderDefinition={YARDI_VOYAGER_DEPOSIT_CREATE_INTENT_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CREATE_INTENT}
			loadingContainer={YardiVoyagerDepositCreateIntentContainer}
			jsonSchema={YARDI_VOYAGER_DEPOSIT_CREATE_INTENT_JSON_SCHEMA}
			customRenderComponents={YARDI_VOYAGER_DEPOSIT_CREATE_INTENT_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function YardiVoyagerDepositCloseIntentsTable({closeIntentUIDList}) {
	return (
		<GenericTable
			incomingUIDList={closeIntentUIDList}
			tableRenderDefinition={YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT}
			loadingContainer={YardiVoyagerDepositCloseIntentContainer}
			jsonSchema={YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT_JSON_SCHEMA}
			customRenderComponents={YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function YardiVoyagerDepositWithholdIntentsTable({withholdIntentUIDList}) {
	return (
		<GenericTable
			incomingUIDList={withholdIntentUIDList}
			tableRenderDefinition={YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT}
			loadingContainer={YardiVoyagerDepositWithholdIntentContainer}
			jsonSchema={YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT_JSON_SCHEMA}
			customRenderComponents={YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function YardiVoyagerEventsTable({eventUIDList}) {
	return (
		<GenericTable
			incomingUIDList={eventUIDList}
			tableRenderDefinition={YARDI_VOYAGER_EVENT_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_EVENT}
			loadingContainer={YardiVoyagerEventContainer}
			jsonSchema={YARDI_VOYAGER_EVENT_JSON_SCHEMA}
			customRenderComponents={YARDI_VOYAGER_EVENT_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function YardiVoyagerFlexDepositIntentsTable({flexIntentUIDList}) {
	return (
		<GenericTable
			incomingUIDList={flexIntentUIDList}
			tableRenderDefinition={YARDI_VOYAGER_FLEX_DEPOSIT_INTENT_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_FLEX_DEPOSIT_INTENT}
			loadingContainer={YardiVoyagerFlexDepositIntentContainer}
			jsonSchema={YARDI_VOYAGER_FLEX_DEPOSIT_INTENT_JSON_SCHEMA}
			customRenderComponents={YARDI_VOYAGER_FLEX_DEPOSIT_INTENT_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function YardiVoyagerPhonesTable({phoneUIDList}) {
	return (
		<GenericTable
			incomingUIDList={phoneUIDList}
			tableRenderDefinition={YARDI_VOYAGER_PHONE_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PHONE}
			loadingContainer={YardiVoyagerPhoneContainer}
			jsonSchema={YARDI_VOYAGER_PHONE_JSON_SCHEMA}
			customRenderComponents={YARDI_VOYAGER_PHONE_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function YardiVoyagerOtherOccupantsTable({otherOccupantUIDList}) {
	return (
		<GenericTable
			incomingUIDList={otherOccupantUIDList}
			tableRenderDefinition={YARDI_VOYAGER_OTHER_OCCUPANT_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_OTHER_OCCUPANT}
			loadingContainer={YardiVoyagerOtherOccupantContainer}
			jsonSchema={YARDI_VOYAGER_OTHER_OCCUPANT_JSON_SCHEMA}
			customRenderComponents={YARDI_VOYAGER_OTHER_OCCUPANT_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function YardiVoyagerPmcCustomColumnSettingsTable({columnUIDList}) {
	return (
		<GenericTable
			incomingUIDList={columnUIDList}
			tableRenderDefinition={YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS}
			loadingContainer={YardiVoyagerPMCCustomColumnSettingsContainer}
			jsonSchema={YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS_JSON_SCHEMA}
			customRenderComponents={YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function YardiVoyagerPmcStatsTable({statsUIDList}) {
	return (
		<GenericTable
			incomingUIDList={statsUIDList}
			tableRenderDefinition={YARDI_VOYAGER_PMC_STATS_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS}
			loadingContainer={YardiVoyagerPMCStatsContainer}
			jsonSchema={YARDI_VOYAGER_PMC_STATS_JSON_SCHEMA}
			customRenderComponents={YARDI_VOYAGER_PMC_STATS_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function YardiVoyagerPmcStatsCollectorsTable({statsUIDList}) {
	return (
		<GenericTable
			incomingUIDList={statsUIDList}
			tableRenderDefinition={YARDI_VOYAGER_PMC_STATS_COLLECTOR_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS_COLLECTOR}
			loadingContainer={YardiVoyagerPMCStatsCollectorContainer}
			jsonSchema={YARDI_VOYAGER_PMC_STATS_COLLECTOR_JSON_SCHEMA}
			customRenderComponents={YARDI_VOYAGER_PMC_STATS_COLLECTOR_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function YardiVoyagerActiveScanLogEntriesTable({logUIDList}) {
	return (
		<GenericTable
			incomingUIDList={logUIDList}
			tableRenderDefinition={YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY}
			loadingContainer={YardiVoyagerActiveScanLogEntryContainer}
			jsonSchema={YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY_JSON_SCHEMA}
			customRenderComponents={YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

export function YardiVoyagerSystemSettingsTable({settingsUIDList}) {
	return (
		<GenericTable
			incomingUIDList={settingsUIDList}
			tableRenderDefinition={YARDI_VOYAGER_SYSTEM_SETTINGS_TABLE_RENDER_DEF}
			resourceType={RESOURCE_TYPE_YARDI_VOYAGER_SYSTEM_SETTINGS}
			loadingContainer={YardiVoyagerSystemSettingsContainer}
			jsonSchema={YARDI_VOYAGER_SYSTEM_SETTINGS_JSON_SCHEMA}
			customRenderComponents={YARDI_VOYAGER_SYSTEM_SETTINGS_CUSTOM_RENDER_COMPONENTS}
		/>
	);
}

